import React from 'react'

export const DropDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 10 6"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m1 1 4 4 4-4"
    />
  </svg>
)
export const SelectIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="13"
    height="10"
    viewBox="0 0 13 10"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 9.75L0.880005 0H12.12L6.5 9.75Z"
      fill="currentColor"
    />
  </svg>
)
export const DealIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width="20" height="20" x="0" y="0" viewBox="0 0 104 104">
    <g>
      <path
        d="M54.52 40.58c-4.74.67-8.88 5.12-8.92 5.16a1 1 0 0 1-.2.16c-6.44 4.18-10.07 1-10.22.81-4.12-3.71-.34-9.93-.18-10.19a37.93 37.93 0 0 1 6.08-7.66H23.59L16 53.9a.92.92 0 0 1 .22.17C28 67.39 43.64 79.21 49.81 83.67a3.15 3.15 0 0 0 4.07-4.79l-8.49-8.49a1 1 0 0 1 0-1.41 1 1 0 0 1 1.42 0l4.52 4.52 4 4 2 2.05a3.83 3.83 0 0 0 5.46-5.37L55 66.05l-1.48-1.53a1 1 0 0 1 0-1.42 1 1 0 0 1 1.42 0l11.37 11.8a4 4 0 0 0 6.81-2.67 3.89 3.89 0 0 0-1.2-2.93l-6.82-6.6-4.75-4.61a1 1 0 1 1 1.39-1.43l13.5 13.07a3.76 3.76 0 1 0 5.15-5.47zM20.54 23A36.92 36.92 0 0 0 4 19.78V59h6.11A3 3 0 0 0 13 56.83l9.18-30.23a3 3 0 0 0-1.64-3.6z"
        fill="currentColor"
        opacity="1"
        data-original="currentColor"
      ></path>
      <path
        d="M57.76 24.94a9.39 9.39 0 0 0-6.76-.15c-3.83 1.4-9.42 4.76-14.33 12.78 0 .06-3.07 5-.18 7.66.1.09 2.68 2.25 7.68-.94.72-.75 5.23-5.27 10.56-5.76a1 1 0 0 1 .76.26l26.21 24c.12.11.23.23.34.35 3-.46 5-3.2 5.58-4.2l-9.5-25.89zM98 24.55a44.21 44.21 0 0 0-16.66 3.14 3 3 0 0 0-1.62 3.83l11.13 30.29a3.07 3.07 0 0 0 2.86 2H100V24.6c-.5-.03-1.19-.05-2-.05z"
        fill="currentColor"
        opacity="1"
        data-original="currentColor"
      ></path>
    </g>
  </svg>
)
export const ViewIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    version="1.1"
    width="20"
    height="20"
    x="0"
    y="0"
    viewBox="0 0 128 128"
    xmlSpace="preserve"
  >
    <g>
      <path
        d="M64 104C22.127 104 1.367 67.496.504 65.943a4 4 0 0 1 0-3.887C1.367 60.504 22.127 24 64 24s62.633 36.504 63.496 38.057a4 4 0 0 1 0 3.887C126.633 67.496 105.873 104 64 104zM8.707 63.994C13.465 71.205 32.146 96 64 96c31.955 0 50.553-24.775 55.293-31.994C114.535 56.795 95.854 32 64 32 32.045 32 13.447 56.775 8.707 63.994zM64 88c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm0-40c-8.822 0-16 7.178-16 16s7.178 16 16 16 16-7.178 16-16-7.178-16-16-16z"
        fill="currentColor"
        opacity="1"
        data-original="currentColor"
      ></path>
    </g>
  </svg>
)
export const Orders = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    version="1.1"
    width="25"
    height="25"
    x="0"
    y="0"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    className=""
  >
    <g>
      <path
        d="M411 8.782V100h91.211z"
        fill="currentColor"
        opacity="1"
        data-original="currentColor"
      ></path>
      <path
        d="M396 130c-8.284 0-15-6.716-15-15V0H166c-24.813 0-45 20.187-45 45v167.689c4.942-.448 9.943-.689 15-.689 51.128 0 96.897 23.376 127.186 60H426c8.284 0 15 6.716 15 15s-6.716 15-15 15H282.948a163.749 163.749 0 0 1 17.363 60H426c8.284 0 15 6.716 15 15s-6.716 15-15 15H300.311c-4.486 49.539-30.954 92.826-69.553 120H466c24.813 0 45-20.187 45-45V130zm30 82H206c-8.284 0-15-6.716-15-15s6.716-15 15-15h220c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
        fill="currentColor"
        opacity="1"
        data-original="currentColor"
      ></path>
      <path
        d="M136 242C61.561 242 1 302.561 1 377s60.561 135 135 135 135-60.561 135-135-60.561-135-135-135zm40 150h-40c-8.284 0-15-6.716-15-15v-60c0-8.284 6.716-15 15-15s15 6.716 15 15v45h25c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
        fill="currentColor"
        opacity="1"
        data-original="currentColor"
      ></path>
    </g>
  </svg>
)
export const DeleteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    version="1.1"
    width="20"
    height="20"
    x="0"
    y="0"
    viewBox="0 0 21 21"
    xmlSpace="preserve"
    fillRule="evenodd"
  >
    <g>
      <g fill="red" fillRule="nonzero">
        <path
          d="M17.741 3.599v.012l-.002.035v.005l-.923 14.522c-.03.483-.235.925-.553 1.244a1.723 1.723 0 0 1-1.23.513h-9.15c-.486 0-.916-.196-1.233-.513a1.92 1.92 0 0 1-.55-1.248L3.26 3.648v-.039l-.001-.023v-.029a.418.418 0 0 1 .414-.421h.004v-.002h13.647a.42.42 0 0 1 .418.465zM15.98 18.12l.9-14.146H4.119l.818 14.15c.016.273.13.521.307.699a.897.897 0 0 0 .639.268h9.15c.25 0 .471-.103.636-.267.178-.18.293-.43.31-.704z"
          fill=""
          opacity="1"
        ></path>
        <path
          d="M1.472 3.974a.42.42 0 0 1 0-.84H19.53a.42.42 0 0 1 0 .84z"
          fill=""
          opacity="1"
        ></path>
        <path
          d="M8.05 1.047h4.902c.333 0 .637.137.858.357l.001.002h.001c.22.221.356.525.356.857v1.291a.42.42 0 0 1-.42.42H7.253a.42.42 0 0 1-.42-.42V2.263c0-.333.136-.637.357-.857v-.001l.001-.001.001-.001c.221-.22.525-.356.857-.356zm4.902.84H8.049a.374.374 0 0 0-.265.11h-.002a.374.374 0 0 0-.11.266v.871h5.656v-.87a.374.374 0 0 0-.109-.266l-.002-.002a.374.374 0 0 0-.265-.11zM7.267 6.443a.42.42 0 0 1 .84 0v10.179a.42.42 0 0 1-.84 0zM10.08 6.443a.42.42 0 0 1 .84 0v10.179a.42.42 0 0 1-.84 0zM12.894 6.443a.42.42 0 0 1 .84 0v10.179a.42.42 0 0 1-.84 0z"
          fill=""
          opacity="1"
        ></path>
      </g>
    </g>
  </svg>
)
export const DesktopIcon = () => (
  <svg width="20" height="20" x="0" y="0" viewBox="0 0 510 510">
    <g>
      <path
        d="m118.188 441.177-41.047-72.529 62.154-35.985c14.384-8.319 28.856-14.848 44.654-9.717l.003.001c20.214 6.554 53.177 20.531 86.851 26.707 8.088 2.854 13.294 10.931 11.056 19.252l-.001.004c-2.205 8.215-9.215 12.208-18.809 11.139-18.52-3.826-35.715-9.447-54.79-14.574-4.264-1.146-8.657 1.386-9.803 5.65s1.386 8.656 5.65 9.802c19.51 5.243 37.092 10.97 56.049 14.862l.011.002c.108.022.216.042.324.06l10.429 1.697.027.004c15.308 2.437 29.355.28 42.758-7.53l84.03-48.941c17.162-9.997 29.774-12.954 38.73-11.077 9.748 2.042 13.454 10.737 12.804 18.618-.422 5.117-2.535 10.108-6.572 12.594l-152.488 93.885-.008.005c-12.073 7.451-25.307 9.138-39.007 5.484L140.59 430.948a8 8 0 0 0-6.072.799zm-58.914-71.614.079.139 48.849 86.316.07.123 10.74 18.977c1.178 2.103.447 4.789-1.645 5.97l-.01.006-23.549 13.348c-2.103 1.177-4.788.446-5.969-1.645l-.003-.006L18.53 370.328l-.003-.004c-1.187-2.095-.457-4.773 1.628-5.951l.007-.004 23.589-13.354c2.091-1.18 4.767-.425 5.965 1.66l.006.01zm-18.699-3.824c-5.349.765-9.042 5.731-8.278 11.08.796 5.349 5.762 9.074 11.111 8.278 5.349-.764 9.042-5.763 8.278-11.111-.796-5.349-5.762-9.043-11.111-8.247zM226.493 77.933l118.262 68.278v53.781l34.294-19.798v-53.781L260.787 58.135l39.484-22.797a5 5 0 0 1 5 0l113.262 65.392a4.999 4.999 0 0 1 2.5 4.33v130.782a5 5 0 0 1-2.5 4.33l-115.762 66.834-115.762-66.834a5 5 0 0 1-2.5-4.33V105.06c0-1.787.953-3.437 2.5-4.33zm185.693-23.987a8.004 8.004 0 0 1-9.798 5.656 8.003 8.003 0 0 1-5.657-9.797l7.738-28.878a8.004 8.004 0 0 1 9.798-5.657 8.005 8.005 0 0 1 5.657 9.798zm40.879 93.856c-4.264-1.147-6.795-5.54-5.648-9.804s5.54-6.794 9.804-5.647l28.898 7.773c4.264 1.147 6.794 5.54 5.647 9.804s-5.54 6.794-9.803 5.647zM452.05 92.44a8.005 8.005 0 0 1-10.929-2.929 8.004 8.004 0 0 1 2.929-10.928l25.938-14.975a8.003 8.003 0 0 1 10.928 2.928 8.003 8.003 0 0 1-2.928 10.928zM208.811 49.805a8.003 8.003 0 0 1-5.657 9.797 8.004 8.004 0 0 1-9.798-5.656l-7.737-28.878a8.004 8.004 0 0 1 5.656-9.798c4.265-1.142 8.656 1.392 9.798 5.657zm-60.49 82.546c4.264-1.147 8.657 1.383 9.804 5.647s-1.384 8.657-5.647 9.804l-28.898 7.773c-4.264 1.147-8.657-1.383-9.804-5.647s1.384-8.657 5.648-9.804zm13.172-53.768c3.823 2.208 5.136 7.105 2.928 10.928a8.004 8.004 0 0 1-10.928 2.929l-25.939-14.976a8.003 8.003 0 0 1-2.928-10.928 8.003 8.003 0 0 1 10.928-2.928z"
        fill="currentColor"
        opacity="1"
        data-original="currentColor"
      ></path>
    </g>
  </svg>
)
export const TableIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="27"
    height="38"
    viewBox="0 0 27 38"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10_74)">
      <path
        d="M19.4994 0H7.50061C3.36538 0 0 3.55234 0 7.91731V30.0827C0 34.4477 3.36538 38 7.50061 38H19.4994C23.6346 38 27 34.4477 27 30.0827V7.91731C27 3.55234 23.6346 0 19.4994 0ZM24.0012 30.0827C24.0012 32.7024 21.9813 34.8346 19.4994 34.8346H7.50061C5.01874 34.8346 2.99878 32.7024 2.99878 30.0827V7.91731C2.99878 5.29756 5.01874 3.16538 7.50061 3.16538H19.4994C21.9813 3.16538 24.0012 5.29756 24.0012 7.91731V30.0827ZM16.5006 30.0827C16.5006 30.9572 15.8297 31.6654 15.0012 31.6654H12.0024C11.1739 31.6654 10.5031 30.9572 10.5031 30.0827C10.5031 29.2081 11.1739 28.5 12.0024 28.5H15.0012C15.8297 28.5 16.5006 29.2081 16.5006 30.0827Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10_74">
        <rect width="27" height="38" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
)
export const MobileIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="20"
    height="29"
    viewBox="0 0 20 29"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10_80)">
      <path
        d="M13.8051 0C13.7745 0 6.22938 0 6.19486 0C2.7733 0.0296637 0 2.72906 0 6.04028V22.9597C0 26.2895 2.80399 29 6.24856 29H13.7476C17.1922 29 19.9962 26.2895 19.9962 22.9597V6.04398C20 2.72906 17.2267 0.0296637 13.8051 0ZM17.5029 22.9597C17.5029 24.9583 15.8189 26.5861 13.7514 26.5861H6.2524C4.18489 26.5861 2.50096 24.9583 2.50096 22.9597V6.04398C2.50096 4.28641 3.79747 2.82176 5.51592 2.48805L6.38281 4.16775C6.59379 4.57563 7.02723 4.83519 7.50288 4.83519H12.5048C12.9804 4.83519 13.41 4.57563 13.6249 4.16775L14.4918 2.48805C16.2064 2.81805 17.5067 4.28641 17.5067 6.04398V22.9634L17.5029 22.9597ZM11.2505 24.1685H8.74952C8.05907 24.1685 7.49904 23.6272 7.49904 22.9597C7.49904 22.2923 8.05907 21.7509 8.74952 21.7509H11.2505C11.9409 21.7509 12.501 22.2923 12.501 22.9597C12.501 23.6272 11.9409 24.1685 11.2505 24.1685Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10_80">
        <rect width="20" height="29" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
)
export const ModalCloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M19.09 19.08a1.42 1.42 0 01-2 0l-5-5.1L7 19.06A1.45 1.45 0 014.5 18a1.38 1.38 0 01.5-1l5-5-5-5a1.41 1.41 0 112-2l5 5 5-5a1.41 1.41 0 012 2l-5 5 5 5.1a1.43 1.43 0 01.09 1.98z"
    ></path>
  </svg>
)
export const PlusIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
      clipRule="evenodd"
    ></path>
  </svg>
)
export const UndoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="37"
    height="32"
    viewBox="0 0 37 32"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.03 4.21002C23.8846 4.16282 25.7297 4.48733 27.4569 5.16443C29.1841 5.84152 30.7582 6.85748 32.0865 8.15247C33.4149 9.44745 34.4707 10.9952 35.1915 12.7046C35.9123 14.414 36.2837 16.2504 36.2837 18.1055C36.2837 19.9607 35.9123 21.797 35.1915 23.5064C34.4707 25.2158 33.4149 26.7635 32.0865 28.0585C30.7582 29.3535 29.1841 30.3695 27.4569 31.0466C25.7297 31.7237 23.8846 32.0482 22.03 32.001H7.12V26.101H22.03C24.1518 26.101 26.1866 25.2582 27.6869 23.7579C29.1872 22.2576 30.03 20.2227 30.03 18.101C30.03 15.9793 29.1872 13.9444 27.6869 12.4442C26.1866 10.9439 24.1518 10.101 22.03 10.101H12.47V14.313L0 7.15302L12.47 0V4.21002H22.03Z"
      fill="currentColor"
    />
  </svg>
)
export const ProdcutsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width="512" height="512" x="0" y="0" viewBox="0 0 512 512">
    <g>
      <path
        d="m391 250-120 40 120 40 120-40zM1 290l120 40 120-40-120-40zM260.743.77a15.005 15.005 0 0 0-9.487 0L136 39.189l120 40 120-40zM136 512l105-35V321.623l-105 35zM1 466.189a14.998 14.998 0 0 0 10.257 14.23L106 512V356.623l-105-35zM271 477l105 35V356.623l-105-35zM406 512l94.743-31.581A15 15 0 0 0 511 466.189V321.623l-105 35zM136 229l105 35V105.812L136 70.811zM376 229V70.811l-105 35.001V264z"
        fill="currentColor"
        opacity="1"
        data-original="currentColor"
      ></path>
    </g>
  </svg>
)
export const SearchIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
    />
  </svg>
)
export const LeftArrow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 447.243 447.243">
    <g>
      <path
        d="M420.361 192.229a31.967 31.967 0 0 0-5.535-.41H99.305l6.88-3.2a63.998 63.998 0 0 0 18.08-12.8l88.48-88.48c11.653-11.124 13.611-29.019 4.64-42.4-10.441-14.259-30.464-17.355-44.724-6.914a32.018 32.018 0 0 0-3.276 2.754l-160 160c-12.504 12.49-12.515 32.751-.025 45.255l.025.025 160 160c12.514 12.479 32.775 12.451 45.255-.063a32.084 32.084 0 0 0 2.745-3.137c8.971-13.381 7.013-31.276-4.64-42.4l-88.32-88.64a64.002 64.002 0 0 0-16-11.68l-9.6-4.32h314.24c16.347.607 30.689-10.812 33.76-26.88 2.829-17.445-9.019-33.88-26.464-36.71z"
        fill="currentColor"
        opacity="1"
        data-original="currentColor"
      ></path>
    </g>
  </svg>
)
export const RightArrow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 492.004 492.004">
    <g>
      <path
        d="M484.14 226.886 306.46 49.202c-5.072-5.072-11.832-7.856-19.04-7.856-7.216 0-13.972 2.788-19.044 7.856l-16.132 16.136c-5.068 5.064-7.86 11.828-7.86 19.04 0 7.208 2.792 14.2 7.86 19.264L355.9 207.526H26.58C11.732 207.526 0 219.15 0 234.002v22.812c0 14.852 11.732 27.648 26.58 27.648h330.496L252.248 388.926c-5.068 5.072-7.86 11.652-7.86 18.864 0 7.204 2.792 13.88 7.86 18.948l16.132 16.084c5.072 5.072 11.828 7.836 19.044 7.836 7.208 0 13.968-2.8 19.04-7.872l177.68-177.68c5.084-5.088 7.88-11.88 7.86-19.1.016-7.244-2.776-14.04-7.864-19.12z"
        fill="currentColor"
        opacity="1"
        data-original="currentColor"
      ></path>
    </g>
  </svg>
)
export const BrandsIcons = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    version="1.1"
    width="512"
    height="512"
    x="0"
    y="0"
    viewBox="0 0 510 510"
    xmlSpace="preserve"
    fillRule="evenodd"
  >
    <g>
      <path
        d="m53.389 352.793 68.639 121.282c1.313 2.341.496 5.332-1.833 6.648l-.01.005-23.329 13.223c-2.341 1.311-5.33.495-6.646-1.834l-.003-.006-68.653-121.31-.003-.004c-1.323-2.334-.507-5.317 1.816-6.629l.007-.004 23.367-13.228c2.328-1.315 5.308-.477 6.641 1.844zM43.86 365.99c-5.299.757-8.957 5.677-8.2 10.976.788 5.298 5.708 8.988 11.007 8.2 5.298-.757 8.957-5.709 8.2-11.007-.789-5.299-5.709-8.957-11.007-8.169zm76.681 75.466L79.35 368.673l62.031-35.914c14.386-8.32 28.87-14.803 44.67-9.672l.003.001c20.016 6.49 52.661 20.337 86.005 26.446 8.303 2.91 13.629 11.203 11.335 19.733l-.001.004c-2.257 8.407-9.413 12.53-19.237 11.427-18.366-3.792-35.415-9.366-54.33-14.449-3.937-1.058-7.992 1.279-9.05 5.216s1.279 7.992 5.216 9.05c19.316 5.191 36.722 10.862 55.491 14.715l10.639 1.738.026.004c15.036 2.393 28.835.279 41.999-7.393l83.24-48.48c17.164-9.999 29.79-12.912 38.747-11.035 9.963 2.087 13.774 10.959 13.11 19.014-.432 5.244-2.628 10.342-6.764 12.89L291.426 454.97l-.007.004c-12.09 7.462-25.342 9.154-39.062 5.494l-109.563-29.363a7.384 7.384 0 0 0-5.605.738zm4.219-383.95a2.462 2.462 0 0 1 4.413 0 61.414 61.414 0 0 0 26.241 26.241 2.464 2.464 0 0 1 0 4.413 61.421 61.421 0 0 0-26.241 26.242 2.462 2.462 0 0 1-4.413-.001 61.417 61.417 0 0 0-26.241-26.24 2.465 2.465 0 0 1 0-4.413 61.421 61.421 0 0 0 26.241-26.242zm332.301 107.742a2.462 2.462 0 0 1 4.413 0 61.414 61.414 0 0 0 26.241 26.241 2.464 2.464 0 0 1 0 4.413 61.421 61.421 0 0 0-26.241 26.242 2.462 2.462 0 0 1-4.413 0 61.414 61.414 0 0 0-26.241-26.241 2.465 2.465 0 0 1 0-4.413 61.421 61.421 0 0 0 26.241-26.242zm0-107.742a2.462 2.462 0 0 1 4.413 0 61.414 61.414 0 0 0 26.241 26.241 2.464 2.464 0 0 1 0 4.413 61.421 61.421 0 0 0-26.241 26.242 2.462 2.462 0 0 1-4.413-.001 61.417 61.417 0 0 0-26.241-26.24 2.465 2.465 0 0 1 0-4.413 61.421 61.421 0 0 0 26.241-26.242zm-320.216 160.7a2.463 2.463 0 0 1 4.413 0 61.42 61.42 0 0 0 26.241 26.241 2.463 2.463 0 0 1 0 4.413 61.42 61.42 0 0 0-26.241 26.241 2.464 2.464 0 0 1-4.413 0 61.425 61.425 0 0 0-26.241-26.241 2.463 2.463 0 0 1 0-4.413 61.425 61.425 0 0 0 26.241-26.241zm236.443 19.172 28.397 61.019c.388.809.291 1.684-.259 2.364-.518.712-1.328 1.036-2.202.874l-34.71-6.055-17.744 30.469c-.421.744-1.198 1.165-2.073 1.133-.874-.032-1.586-.518-1.975-1.328l-25.443-54.648c17.504 4.551 35.394-2.293 45.379-17.576l10.57-16.163.06-.089zM271.32 271.206l-25.444 54.648c-.356.81-1.101 1.296-1.975 1.328s-1.651-.389-2.072-1.133l-17.712-30.469-34.743 6.055a2.16 2.16 0 0 1-2.202-.874c-.55-.68-.647-1.555-.259-2.364l28.398-61.019.049.074 10.585 16.185c9.981 15.276 27.87 22.12 45.375 17.569zm38.408-250.585 15.51 11.624c4.241 3.173 8.677 4.792 13.987 5.083l19.331 1.069c11.559.647 20.981 8.548 23.604 19.816l4.436 18.877c1.198 5.148 3.562 9.26 7.447 12.887l14.118 13.243c8.451 7.933 10.588 20.043 5.342 30.372l-8.742 17.29c-2.364 4.728-3.206 9.39-2.558 14.668l2.299 19.233c1.36 11.495-4.76 22.148-15.445 26.713l-17.776 7.609c-4.889 2.073-8.516 5.149-11.43 9.585l-10.588 16.189c-6.346 9.714-17.873 13.891-28.98 10.556l-18.553-5.602c-5.051-1.554-9.811-1.554-14.862 0l-18.553 5.602c-11.106 3.335-22.633-.842-28.98-10.556l-10.588-16.189c-2.914-4.436-6.54-7.512-11.429-9.585l-17.777-7.609c-10.652-4.565-16.804-15.218-15.445-26.713l2.299-19.233c.648-5.278-.194-9.94-2.558-14.668l-8.742-17.29c-5.245-10.329-3.108-22.439 5.343-30.372l14.117-13.243c3.885-3.627 6.249-7.739 7.447-12.887l4.436-18.877c2.623-11.268 12.045-19.169 23.605-19.816l19.33-1.069c5.31-.291 9.779-1.91 13.988-5.083l15.509-11.624c9.293-6.93 21.565-6.93 30.858 0zm-15.41 195.855c44.288 0 80.45-36.162 80.45-80.488S338.606 55.5 294.318 55.5c-44.326 0-80.487 36.162-80.487 80.488s36.161 80.488 80.487 80.488zm-5.157-130.827a5.403 5.403 0 0 1 10.276 0l9.154 28.172a5.402 5.402 0 0 0 5.138 3.733h29.621a5.402 5.402 0 0 1 3.175 9.773l-23.964 17.411a5.403 5.403 0 0 0-1.962 6.04l9.153 28.172a5.402 5.402 0 0 1-8.313 6.04l-23.964-17.411a5.402 5.402 0 0 0-6.351 0L267.16 184.99a5.403 5.403 0 0 1-8.314-6.04L268 150.778a5.404 5.404 0 0 0-1.963-6.04l-23.964-17.411a5.402 5.402 0 0 1 3.175-9.773h29.622a5.403 5.403 0 0 0 5.138-3.733z"
        fill="currentColor"
        opacity="1"
        data-original="currentColor"
      ></path>
    </g>
  </svg>
)
export const CopyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g data-name="Group 12173">
      <path
        data-name="Path 15541"
        d="M17.094 19.004h-5.728a1.876 1.876 0 01-1.91-1.91v-5.728a1.876 1.876 0 011.91-1.91h5.729a1.876 1.876 0 011.91 1.91v5.729a1.876 1.876 0 01-1.911 1.909zm-5.728-8.275a.6.6 0 00-.637.637v5.729a.6.6 0 00.637.637h5.729a.6.6 0 00.637-.637v-5.729a.6.6 0 00-.637-.637z"
      ></path>
    </g>
    <g data-name="Group 12174">
      <path
        data-name="Path 15542"
        d="M7.546 14.548H6.91A1.876 1.876 0 015 12.638V6.91A1.876 1.876 0 016.91 5h5.728a1.876 1.876 0 011.91 1.91v.637a.637.637 0 11-1.273 0V6.91a.6.6 0 00-.637-.637H6.91a.6.6 0 00-.637.637v5.728a.6.6 0 00.637.637h.637a.637.637 0 110 1.273z"
      ></path>
    </g>
    <path data-name="Rectangle 15110" fill="none" d="M0 0h24v24H0z"></path>
  </svg>
)
export const MoveIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="24"
    height="24"
    x="0"
    y="0"
    viewBox="0 0 32 32"
  >
    <g>
      <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
        <path
          d="M11.755 24.755a1 1 0 0 1 1.415 0l2.83 2.83 2.83-2.83a1 1 0 0 1 1.415 1.415l-3.538 3.537a1 1 0 0 1-1.414 0l-3.538-3.537a1 1 0 0 1 0-1.415z"
          fill="currentColor"
          opacity="1"
          data-original="currentColor"
        ></path>
        <path
          d="M16 19a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0v-9a1 1 0 0 1 1-1zM15.293 2.293a1 1 0 0 1 1.414 0l3.538 3.537a1 1 0 0 1-1.415 1.415L16 4.415l-2.83 2.83a1 1 0 1 1-1.415-1.415z"
          fill="currentColor"
          opacity="1"
          data-original="currentColor"
        ></path>
        <path
          d="M16 2a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1zM7.245 11.755a1 1 0 0 1 0 1.415L4.415 16l2.83 2.83a1 1 0 1 1-1.415 1.415l-3.537-3.538a1 1 0 0 1 0-1.414l3.537-3.538a1 1 0 0 1 1.415 0z"
          fill="currentColor"
          opacity="1"
          data-original="currentColor"
        ></path>
        <path
          d="M2 16a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1zM24.755 11.755a1 1 0 0 1 1.415 0l3.537 3.538a1 1 0 0 1 0 1.414l-3.537 3.538a1 1 0 1 1-1.415-1.415l2.83-2.83-2.83-2.83a1 1 0 0 1 0-1.415z"
          fill="currentColor"
          opacity="1"
          data-original="currentColor"
        ></path>
        <path
          d="M19 16a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1z"
          fill="currentColor"
          opacity="1"
          data-original="currentColor"
        ></path>
      </g>
    </g>
  </svg>
)
export const EyeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="24"
    height="24"
    x="0"
    y="0"
    viewBox="0 0 512 512"
  >
    <g>
      <path
        d="M508.745 246.041c-4.574-6.257-113.557-153.206-252.748-153.206S7.818 239.784 3.249 246.035a16.896 16.896 0 0 0 0 19.923c4.569 6.257 113.557 153.206 252.748 153.206s248.174-146.95 252.748-153.201a16.875 16.875 0 0 0 0-19.922zM255.997 385.406c-102.529 0-191.33-97.533-217.617-129.418 26.253-31.913 114.868-129.395 217.617-129.395 102.524 0 191.319 97.516 217.617 129.418-26.253 31.912-114.868 129.395-217.617 129.395z"
        fill="currentColor"
        opacity="1"
        data-original="currentColor"
      ></path>
      <path
        d="M255.997 154.725c-55.842 0-101.275 45.433-101.275 101.275s45.433 101.275 101.275 101.275S357.272 311.842 357.272 256s-45.433-101.275-101.275-101.275zm0 168.791c-37.23 0-67.516-30.287-67.516-67.516s30.287-67.516 67.516-67.516 67.516 30.287 67.516 67.516-30.286 67.516-67.516 67.516z"
        fill="currentColor"
        opacity="1"
        data-original="currentColor"
      ></path>
    </g>
  </svg>
)
export const EyeCloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="28"
    height="28"
    x="0"
    y="0"
    viewBox="0 0 48 48"
  >
    <g>
      <path
        d="M19.356 13.72c1.578-.515 3.14-.776 4.644-.776 8.531 0 16.04 8.296 18.303 11.057a41.695 41.695 0 0 1-4.247 4.46 1.501 1.501 0 0 0 2.012 2.226c3.273-2.959 5.271-5.692 5.355-5.807a1.5 1.5 0 0 0 0-1.763C45.032 22.581 35.72 9.944 24 9.944c-1.82 0-3.695.311-5.574.924a1.498 1.498 0 0 0-.96 1.891 1.497 1.497 0 0 0 1.89.961zM4.777 4a1.5 1.5 0 0 0-1.971 2.262l9.087 7.919c-5.52 3.772-9.151 8.712-9.315 8.938a1.503 1.503 0 0 0 0 1.763c.39.537 9.702 13.174 21.422 13.174 3.62 0 7.366-1.225 11.145-3.612l8.078 7.04a1.496 1.496 0 0 0 2.116-.146 1.5 1.5 0 0 0-.146-2.116zm15.252 17.27 6.732 5.867a4.58 4.58 0 0 1-2.761.938 4.581 4.581 0 0 1-4.575-4.575c0-.8.223-1.555.604-2.23zM24 35.056c-8.531 0-16.039-8.295-18.302-11.057 1.326-1.621 4.467-5.135 8.548-7.768l3.476 3.03a7.504 7.504 0 0 0-1.298 4.239c0 4.177 3.398 7.575 7.575 7.575 1.879 0 3.674-.71 5.051-1.942l3.727 3.248c-3.022 1.771-5.969 2.675-8.777 2.675z"
        fill="currentColor"
        opacity="1"
        data-original="currentColor"
      ></path>
    </g>
  </svg>
)
export const ColorPalette = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10_86)">
      <path
        d="M19.8714 9.39169C18.9366 9.63867 18.3801 10.5985 18.6302 11.5333C18.8772 12.4681 19.837 13.0246 20.7718 12.7744C21.7066 12.5275 22.2631 11.5677 22.0129 10.6329C21.766 9.69807 20.8062 9.14158 19.8714 9.39169Z"
        fill="currentColor"
      />
      <path
        d="M14.0375 5.89326C13.1027 6.14024 12.5462 7.10005 12.7963 8.03484C13.0433 8.96963 14.0031 9.52613 14.9379 9.27602C15.8727 9.02903 16.4292 8.06923 16.1791 7.13444C15.9321 6.19965 14.9723 5.64315 14.0375 5.89326Z"
        fill="currentColor"
      />
      <path
        d="M8.20364 9.39169C7.26884 9.63867 6.71235 10.5985 6.96246 11.5333C7.20944 12.4681 8.16925 13.0246 9.10404 12.7744C10.0388 12.5275 10.5953 11.5677 10.3452 10.6329C10.0982 9.69807 9.13843 9.14158 8.20364 9.39169Z"
        fill="currentColor"
      />
      <path
        d="M8.20364 16.3917C7.26884 16.6387 6.71235 17.5985 6.96246 18.5333C7.20944 19.4681 8.16925 20.0246 9.10404 19.7744C10.0388 19.5275 10.5953 18.5677 10.3452 17.6329C10.0982 16.6981 9.13843 16.1416 8.20364 16.3917Z"
        fill="currentColor"
      />
      <path
        d="M14.4877 0.00931711C6.75927 -0.259553 0.278249 5.7869 0.00937919 13.5122C0 13.6748 0 13.8374 0 13.9999C0.00937919 21.7284 6.27155 27.9906 14 27.9999C14.3939 27.9999 14.7816 27.9749 15.1661 27.9405C15.7727 27.8905 16.2385 27.3809 16.2354 26.7744L16.1979 22.5881C16.1728 20.2902 18.0143 18.405 20.3122 18.38C21.4314 18.3675 22.5101 18.8083 23.3042 19.5993L23.4198 19.715C23.9576 20.259 24.736 20.4872 25.4833 20.3215C26.218 20.1683 26.8245 19.6493 27.0902 18.949C27.7343 17.2576 28.0438 15.4568 27.9969 13.6467C27.7249 6.28399 21.8504 0.353221 14.4877 0.00931711ZM24.9643 17.9767L24.9486 17.9611C22.41 15.4256 18.2988 15.4287 15.7633 17.9673C14.5346 19.1991 13.8499 20.8686 13.8656 22.61L13.8937 25.6676C7.4502 25.6395 2.25101 20.3903 2.27914 13.9499C2.30728 7.50641 7.5565 2.30722 13.9969 2.33536C14.1344 2.33536 14.272 2.33536 14.4096 2.34161C20.5435 2.62924 25.4364 7.57207 25.6615 13.7092C25.699 15.1598 25.4645 16.6042 24.9674 17.9673V17.9767H24.9643Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10_86">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export const TextFormat = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.3745 0H5.6255C2.52032 0.00301474 0.00301474 2.52032 0 5.6255V21.3745C0.00301474 24.4797 2.52032 26.997 5.6255 27H21.3745C24.4797 26.997 26.997 24.4797 27 21.3745V5.6255C26.997 2.52032 24.4797 0.00301474 21.3745 0ZM24.751 21.3745C24.751 23.2376 23.2406 24.748 21.3775 24.748H5.6255C3.76239 24.748 2.25201 23.2376 2.25201 21.3745V5.6255C2.25201 3.76239 3.76239 2.25201 5.6255 2.25201H21.3745C23.2376 2.25201 24.748 3.76239 24.748 5.6255V21.3745H24.751ZM20.25 10.1235C20.25 10.7445 19.7465 11.248 19.1255 11.248C18.5045 11.248 18.001 10.7445 18.001 10.1235C18.001 9.50246 17.4975 8.999 16.8765 8.999H14.6275V17.998H15.752C16.373 17.998 16.8765 18.5015 16.8765 19.1225C16.8765 19.7435 16.373 20.247 15.752 20.247H11.251C10.63 20.247 10.1265 19.7435 10.1265 19.1225C10.1265 18.5015 10.63 17.998 11.251 17.998H12.3755V8.999H10.1265C9.50547 8.999 9.00201 9.50246 9.00201 10.1235C9.00201 10.7445 8.49855 11.248 7.87751 11.248C7.25648 11.248 6.75302 10.7445 6.75302 10.1235C6.75302 8.26039 8.2634 6.75 10.1265 6.75H16.8765C18.7396 6.75 20.25 8.26039 20.25 10.1235Z"
      fill="white"
    />
  </svg>
)
export const PhotoEditing = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="512"
    height="512"
    viewBox="0 0 26 26"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.20446 5.41715C10.104 5.41715 10.8295 6.14292 10.8295 7.04288C10.8295 7.94283 10.104 8.6686 9.20446 8.6686C8.30491 8.6686 7.57946 7.94283 7.57946 7.04288C7.57946 6.14292 8.30491 5.41715 9.20446 5.41715ZM17.1292 8.86021L16.7491 7.32157C16.6301 6.84547 16.1978 6.4971 15.6987 6.4971C15.1996 6.4971 14.7672 6.83385 14.6482 7.32157L14.2681 8.84859L12.7533 9.19406C12.2658 9.30147 11.9205 9.73694 11.9205 10.2334C11.9205 10.7298 12.2455 11.1653 12.7214 11.2959L14.271 11.7197L14.6598 13.27C14.7788 13.7461 15.2112 14.0945 15.7103 14.0945C16.2094 14.0945 16.6417 13.7577 16.7607 13.27L17.1408 11.7314L18.6788 11.351C19.1547 11.232 19.5029 10.7995 19.5029 10.3001C19.5029 9.8008 19.1663 9.36825 18.6788 9.24922L17.1408 8.86891L17.1292 8.8573V8.86021ZM17.9853 5.28651L19.8917 6.08776L20.6491 7.98347C20.8116 8.39571 21.2121 8.6657 21.656 8.6657C22.1 8.6657 22.5004 8.39571 22.6629 7.98347L23.4203 6.09937L25.3036 5.34167C25.7156 5.1791 25.9855 4.77847 25.9855 4.3343C25.9855 3.89013 25.7156 3.4895 25.3036 3.32693L23.4203 2.56923L22.6629 0.685127C22.5004 0.269987 22.1 0 21.656 0C21.2121 0 20.8116 0.269987 20.6491 0.682224L19.9033 2.55762L18.0288 3.27177C17.6167 3.42273 17.3353 3.82336 17.3237 4.26753C17.3237 4.7117 17.5732 5.11233 17.9853 5.28651ZM25.9884 9.74855V20.5828C25.9884 23.573 23.5625 26 20.5737 26H5.41473C2.42589 26 0 23.573 0 20.5828V5.41715C0 2.42698 2.42589 0 5.41473 0H16.2442C16.8391 0 17.3266 0.487718 17.3266 1.08285C17.3266 1.67798 16.8391 2.1657 16.2442 2.1657H5.41473C3.62723 2.1657 2.16763 3.62885 2.16763 5.41425V12.5529L2.77411 11.9462C4.225 10.4946 6.59576 10.4946 8.05826 11.9462L14.0998 17.9904C14.6859 18.5768 15.6493 18.5768 16.2326 17.9904L16.8594 17.3633C18.3103 15.9118 20.681 15.9118 22.1435 17.3633L23.8324 19.0529V9.74855C23.8324 9.15342 24.3199 8.6657 24.9147 8.6657C25.5096 8.6657 25.9971 9.15342 25.9971 9.74855H25.9855H25.9884ZM23.5625 21.8515L20.5969 18.8845C19.9904 18.2778 18.9951 18.2778 18.377 18.8845L17.7502 19.5116C16.3196 20.9428 13.9808 20.9428 12.5531 19.5116L6.51161 13.4674C5.90513 12.8607 4.90982 12.8607 4.29174 13.4674L2.14732 15.6128V20.5858C2.14732 22.3741 3.60982 23.8343 5.39442 23.8343H20.5533C21.8969 23.8343 23.0431 23.0214 23.5422 21.8515H23.5625Z"
      fill="currentColor"
    />
  </svg>
)
export const HomeOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="512"
    height="512"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.8332 6.20466V2.17087C23.8332 1.57279 23.3487 1.08792 22.75 1.08792C22.1513 1.08792 21.6668 1.5733 21.6668 2.17087V4.7333L16.0301 0.930531C14.1893 -0.310828 11.8107 -0.310828 9.96988 0.930531L2.38672 6.04727C0.892734 7.05609 0 8.73358 0 10.537V20.5841C0 23.5705 2.42988 25.9999 5.41684 25.9999H8.66684C9.26606 25.9999 9.75 25.5145 9.75 24.9169V16.2518C9.75 15.6552 10.2355 15.1688 10.8332 15.1688H15.1663C15.7645 15.1688 16.2495 15.6552 16.2495 16.2518V24.9169C16.2495 25.515 16.7339 25.9999 17.3327 25.9999H20.5827C23.5696 25.9999 25.9995 23.5705 25.9995 20.5841V10.537C25.9995 8.82446 25.1936 7.22465 23.8327 6.20466H23.8332ZM23.8332 20.5841C23.8332 22.3758 22.3752 23.8335 20.5832 23.8335H18.4163V16.2518C18.4163 14.4601 16.9584 13.0024 15.1663 13.0024H10.8332C9.04109 13.0024 7.58316 14.4601 7.58316 16.2518V23.8335H5.41633C3.62426 23.8335 2.16633 22.3758 2.16633 20.5841V10.537C2.16633 9.45504 2.70156 8.44774 3.59836 7.84305L11.182 2.72682C12.287 1.9815 13.7125 1.9815 14.8164 2.72682L22.3996 7.84356C23.2964 8.44774 23.8316 9.45504 23.8316 10.5375V20.5846H23.8327L23.8332 20.5841Z"
      fill="currentColor"
    />
  </svg>
)
export const Templates = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="512"
    height="512"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_115_474)">
      <path
        d="M3.1075 10.0863H10.3575C12.07 10.0863 13.465 8.6925 13.465 6.97875V3.1075C13.465 1.395 12.0712 0 10.3575 0H3.1075C1.39375 0 0 1.39375 0 3.1075V6.97875C0 8.69125 1.39375 10.0863 3.1075 10.0863ZM2.07125 3.1075C2.07125 2.53625 2.535 2.07125 3.1075 2.07125H10.3575C10.9288 2.07125 11.3938 2.53625 11.3938 3.1075V6.97875C11.3938 7.55 10.93 8.015 10.3575 8.015H3.1075C2.53625 8.015 2.07125 7.55 2.07125 6.97875V3.1075Z"
        fill="currentColor"
      />
      <path
        d="M13.4637 25.8924V14.8824C13.4637 13.1699 12.07 11.7749 10.3562 11.7749H3.1075C1.395 11.7749 0 13.1687 0 14.8824V25.8924C0 27.6049 1.39375 28.9999 3.1075 28.9999H10.3575C12.07 28.9999 13.465 27.6062 13.465 25.8924H13.4637ZM2.07125 25.8924V14.8824C2.07125 14.3112 2.535 13.8462 3.1075 13.8462H10.3575C10.9288 13.8462 11.3938 14.3112 11.3938 14.8824V25.8924C11.3938 26.4637 10.93 26.9287 10.3575 26.9287H3.1075C2.53625 26.9287 2.07125 26.4637 2.07125 25.8924Z"
        fill="currentColor"
      />
      <path
        d="M25.8925 18.9136H18.6425C16.93 18.9136 15.535 20.3073 15.535 22.0211V25.8923C15.535 27.6048 16.9287 28.9998 18.6425 28.9998H25.8925C27.605 28.9998 29 27.6061 29 25.8923V22.0211C29 20.3086 27.6062 18.9136 25.8925 18.9136ZM26.9287 25.8923C26.9287 26.4636 26.465 26.9286 25.8925 26.9286H18.6425C18.0712 26.9286 17.6062 26.4636 17.6062 25.8923V22.0211C17.6062 21.4498 18.07 20.9848 18.6425 20.9848H25.8925C26.4637 20.9848 26.9287 21.4498 26.9287 22.0211V25.8923Z"
        fill="currentColor"
      />
      <path
        d="M25.8925 0H18.6425C16.93 0 15.535 1.39375 15.535 3.1075V14.1175C15.535 15.83 16.9287 17.225 18.6425 17.225H25.8925C27.605 17.225 29 15.8313 29 14.1175V3.1075C29 1.39375 27.6062 0 25.8925 0ZM26.9287 14.1163C26.9287 14.6875 26.465 15.1525 25.8925 15.1525H18.6425C18.0712 15.1525 17.6062 14.6875 17.6062 14.1163V3.1075C17.6062 2.53625 18.07 2.07125 18.6425 2.07125H25.8925C26.4637 2.07125 26.9287 2.53625 26.9287 3.1075V14.1175V14.1163Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_115_474">
        <rect width="29" height="29" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export const Sites = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="512"
    height="512"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.3964 13.0211L22.8992 10.7733L27.3964 8.52545C28.2008 8.12384 28.202 6.9718 27.3964 6.56905L14.4889 0.115807C14.1813 -0.0379512 13.8187 -0.0379512 13.51 0.115807L0.603628 6.5679C-0.200798 6.97065 -0.201946 8.12154 0.603628 8.5243L5.10084 10.7721L0.603628 13.0211C-0.200798 13.4239 -0.201946 14.5748 0.603628 14.9775L5.10084 17.2254L0.603628 19.4732C-0.200798 19.876 -0.201946 21.0269 0.603628 21.4296L13.5112 27.8829C13.8187 28.0366 14.1813 28.0366 14.49 27.8829L27.3976 21.4296C28.202 21.0269 28.2031 19.876 27.3976 19.4732L22.9003 17.2254L27.3976 14.9775C28.202 14.5759 28.2031 13.4239 27.3976 13.0211H27.3964ZM14 2.31661L24.461 7.54667L14 12.7767L3.53904 7.54667L14 2.31661ZM24.461 20.4532L14 25.6832L3.53904 20.4532L7.54625 18.4497L13.5112 21.4319C13.8187 21.5857 14.1813 21.5857 14.49 21.4319L20.4549 18.4497L24.4622 20.4532H24.461ZM14 19.23L3.53904 13.9999L7.54625 11.9965L13.5112 14.9787C13.8187 15.1324 14.1813 15.1324 14.49 14.9787L20.4549 11.9965L24.4622 13.9999L14.0012 19.23H14Z"
      fill="currentColor"
    />
  </svg>
)
export const BillingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_286_437)">
      <path
        d="M21 0H6.5C4.57 0 3 1.57 3 3.5V7C3 7.55 3.45 8 4 8C4.55 8 5 7.55 5 7V3.5C5 2.67 5.67 2 6.5 2C7.33 2 8 2.67 8 3.5C8 4.88 9.12 6 10.5 6H19V19C19 20.65 17.65 22 16 22H14C13.45 22 13 22.45 13 23C13 23.55 13.45 24 14 24H16C18.76 24 21 21.76 21 19V6H21.5C22.88 6 24 4.88 24 3.5V3C24 1.35 22.65 0 21 0ZM22 3.5C22 3.78 21.78 4 21.5 4H10.5C10.22 4 10 3.78 10 3.5C10 2.96 9.88 2.45 9.66 2H21C21.55 2 22 2.45 22 3V3.5ZM8.5 10H3.5C1.57 10 0 11.57 0 13.5V20.5C0 22.43 1.57 24 3.5 24H8.5C10.43 24 12 22.43 12 20.5V13.5C12 11.57 10.43 10 8.5 10ZM10 20.5C10 21.33 9.33 22 8.5 22H3.5C2.67 22 2 21.33 2 20.5V13.5C2 12.67 2.67 12 3.5 12H8.5C9.33 12 10 12.67 10 13.5V20.5ZM9 14C9 14.55 8.55 15 8 15H4C3.45 15 3 14.55 3 14C3 13.45 3.45 13 4 13H8C8.55 13 9 13.45 9 14ZM9 17C9 17.55 8.55 18 8 18H7.5C6.95 18 6.5 17.55 6.5 17C6.5 16.45 6.95 16 7.5 16H8C8.55 16 9 16.45 9 17ZM5.5 17C5.5 17.55 5.05 18 4.5 18H4C3.45 18 3 17.55 3 17C3 16.45 3.45 16 4 16H4.5C5.05 16 5.5 16.45 5.5 17ZM9 20C9 20.55 8.55 21 8 21H7.5C6.95 21 6.5 20.55 6.5 20C6.5 19.45 6.95 19 7.5 19H8C8.55 19 9 19.45 9 20ZM5.5 20C5.5 20.55 5.05 21 4.5 21H4C3.45 21 3 20.55 3 20C3 19.45 3.45 19 4 19H4.5C5.05 19 5.5 19.45 5.5 20Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_286_437">
        <rect width="24" height="24" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
)
export const Subscriptions = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12.9999V8.74993C12 8.42993 11.81 8.14993 11.5 8.03993C11.2 7.92993 10.87 8.01993 10.65 8.28993L9.5 9.98993L8.27 8.30993C7.84 7.88993 7.15 7.89993 6.69 8.35993L5.5 9.98993L4.25 8.19993C4.25 8.19993 4.2 8.13993 4.17 8.11993C3.98 7.97993 3.69 7.96993 3.44 8.07993C3.17 8.19993 3.01 8.46993 3.01 8.75993V12.9899C1.35 12.9999 0 14.3499 0 15.9999V20.9999C0 22.6499 1.35 23.9999 3 23.9999H12C13.65 23.9999 15 22.6499 15 20.9999V15.9999C15 14.3499 13.65 12.9999 12 12.9999ZM2 20.9999V15.9999C2 15.4499 2.45 14.9999 3 14.9999H6.5V21.9999H3C2.45 21.9999 2 21.5499 2 20.9999ZM13 20.9999C13 21.5499 12.55 21.9999 12 21.9999H8.5V14.9999H12C12.55 14.9999 13 15.4499 13 15.9999V20.9999ZM19.23 14.4499C19.74 14.4799 20.32 14.1399 20.76 13.9099C22.33 13.1499 23 11.2499 22.24 9.66993L21.29 7.67993C21.45 7.79993 21.6 7.90993 21.71 7.97993C22.42 8.40993 23.35 8.18993 23.78 7.46993C24.21 6.75993 23.99 5.82993 23.27 5.39993C22.7 5.05993 22.05 4.97993 21.42 5.01993C21.84 4.46993 22.17 3.80993 22.17 3.07993C22.17 2.24993 21.5 1.56993 20.66 1.56993C19.82 1.56993 19.15 2.24993 19.15 3.07993C19.15 3.12993 19.15 3.18993 19.15 3.24993L18.46 1.79993C18.09 1.02993 17.45 0.459929 16.65 0.179929C15.85 -0.100071 14.98 -0.0500706 14.2 0.319929L13.52 0.669929C12.54 1.16993 12.15 2.32993 12.63 3.31993L17.43 13.3199C17.75 14.0099 18.48 14.4599 19.24 14.4599L19.23 14.4499ZM14.43 2.44993L15.09 2.10993C15.25 2.02993 15.43 1.98993 15.6 1.98993C15.73 1.98993 15.86 2.00993 15.99 2.05993C16.29 2.15993 16.53 2.37993 16.66 2.65993L20.43 10.5299C20.71 11.1199 20.46 11.8199 19.88 12.1099C19.88 12.1099 19.86 12.1099 19.86 12.1199L19.22 12.4399L14.43 2.44993ZM0 2.45993C0 2.19993 0.17 1.97993 0.4 1.88993L1.48 1.47993L1.91 0.399929C2.1 -0.120071 2.88 -0.120071 3.07 0.399929L3.51 1.48993L4.6 1.92993C5.11 2.11993 5.11 2.90993 4.6 3.08993L3.51 3.52993L3.07 4.61993C2.88 5.12993 2.1 5.12993 1.91 4.61993L1.47 3.51993L0.37 3.05993C0.15 2.94993 0 2.71993 0 2.45993ZM7 4.45993C7 4.19993 7.16 3.97993 7.4 3.88993L8.48 3.47993L8.91 2.39993C9.1 1.88993 9.89 1.88993 10.07 2.39993L10.51 3.48993L11.6 3.92993C12.12 4.11993 12.12 4.89993 11.6 5.08993L10.51 5.52993L10.07 6.61993C9.88 7.12993 9.09 7.12993 8.91 6.61993L8.47 5.51993L7.37 5.05993C7.13 4.95993 6.98 4.72993 6.99 4.46993L7 4.45993ZM24 19.9999C24 20.3099 23.81 20.5799 23.53 20.6999L22.22 21.2199L21.7 22.5299C21.48 23.1499 20.53 23.1499 20.31 22.5299L19.78 21.2099L18.46 20.6499C17.85 20.4099 17.86 19.4699 18.49 19.2599L19.79 18.7699L20.31 17.4699C20.53 16.8499 21.48 16.8499 21.7 17.4699L22.22 18.7799L23.53 19.2999C23.81 19.4099 24 19.6899 24 19.9999Z"
      fill="currentColor"
    />
  </svg>
)
export const VideoTutorials = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="27"
    height="24"
    viewBox="0 0 27 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_146_75)">
      <path
        d="M27 0H15.6094C14.7788 0 14.0295 0.35312 13.5 0.916418C12.9705 0.352591 12.2212 0 11.3906 0H0V19.0944H6.06287C7.31004 21.9782 10.174 24.0005 13.5 24.0005C16.826 24.0005 19.69 21.9782 20.9371 19.0944H27V0ZM25.418 17.5062H21.4376C21.5462 16.9757 21.6032 16.4272 21.6032 15.865C21.6032 15.2276 21.5299 14.6076 21.3912 14.012H23.2295V12.4238H20.8417C20.5374 11.7721 20.1498 11.1675 19.6921 10.6238H23.2295V9.03554H17.8986C16.8397 8.34571 15.6115 7.89729 14.291 7.76865V2.91179C14.291 2.18225 14.8822 1.58825 15.6094 1.58825H25.418V17.5062ZM13.5 22.4118C9.90404 22.4118 6.97834 19.4746 6.97834 15.8645C6.97834 12.2544 9.90404 9.31719 13.5 9.31719C17.096 9.31719 20.0217 12.2544 20.0217 15.8645C20.0217 19.4746 17.096 22.4118 13.5 22.4118ZM1.58203 1.58825H11.3906C12.1178 1.58825 12.709 2.18172 12.709 2.91179V7.76812C11.3885 7.89729 10.1603 8.34571 9.10143 9.03501H3.77051V10.6233H7.3074C6.8502 11.167 6.46207 11.7716 6.15779 12.4233H3.76998V14.0115H5.6083C5.46961 14.6071 5.39578 15.2271 5.39578 15.8645C5.39578 16.4267 5.45273 16.9752 5.56137 17.5057H1.58203V1.58825Z"
        fill="currentColor"
      />
      <path d="M3.77051 5.64746H10.5205V7.23571H3.77051V5.64746Z" fill="currentColor" />
      <path d="M16.4795 5.64746H23.2295V7.23571H16.4795V5.64746Z" fill="currentColor" />
      <path
        d="M17.2705 16.5529V15.1774L11.7914 12.0015L10.6049 12.6892V19.0406L11.7914 19.7283L17.2705 16.5523V16.5529ZM12.1869 14.0646L15.2929 15.8651L12.1869 17.6657V14.0651V14.0646Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_146_75">
        <rect width="27" height="24" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
)
export const Info = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28 14C28 21.732 21.732 28 14.0001 28C6.26807 28 0 21.732 0 14C0 6.26804 6.26796 0 13.9999 0C21.7319 0 27.9999 6.26804 27.9999 14H28ZM25.6798 13.9974C25.6798 7.54693 20.4507 2.31777 14.0002 2.31777C7.54967 2.31777 2.32055 7.54693 2.32055 13.9974C2.32055 20.4479 7.54967 25.6771 14.0002 25.6771C20.4507 25.6771 25.6798 20.4479 25.6798 13.9974Z"
      fill="currentColor"
    />
    <path
      d="M13.4425 5.85934C17.7203 5.44248 20.3422 10.3606 17.5025 13.5865C16.6324 14.5749 15.3501 14.7435 15.1658 16.2852C15.0748 17.0455 15.3995 17.9463 14.6544 18.4556C13.9091 18.9652 12.928 18.4626 12.8496 17.5857C12.6957 15.8646 13.1142 14.1574 14.4681 13.0149C15.0997 12.482 15.7873 12.3075 16.1456 11.4631C17.0607 9.30667 14.717 7.26415 12.6922 8.55703C11.7553 9.15522 11.8143 9.73125 11.6432 10.6826C11.398 12.0472 9.22163 12.0838 9.34967 10.0858C9.48431 7.98536 11.3492 6.06329 13.4426 5.85934H13.4425Z"
      fill="currentColor"
    />
  </svg>
)
export const EditIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    version="1.1"
    width="20"
    height="20"
    x="0"
    y="0"
    viewBox="0 0 484 484"
    xmlSpace="preserve"
    className=""
  >
    <g>
      <path
        d="M401.648 18.234c-24.394-24.351-63.898-24.351-88.293 0l-22.101 22.223-235.27 235.145-.5.503c-.12.122-.12.25-.25.25-.25.375-.625.747-.87 1.122 0 .125-.13.125-.13.25-.25.375-.37.625-.625 1-.12.125-.12.246-.246.375-.125.375-.25.625-.379 1 0 .12-.12.12-.12.25L.663 437.32a12.288 12.288 0 0 0 2.996 12.735 12.564 12.564 0 0 0 8.867 3.625c1.356-.024 2.7-.235 3.996-.625l156.848-52.325c.121 0 .121 0 .25-.12a4.523 4.523 0 0 0 1.121-.505.443.443 0 0 0 .254-.12c.371-.25.871-.505 1.246-.755.371-.246.75-.62 1.125-.87.125-.13.246-.13.246-.25.13-.126.38-.247.504-.5l257.371-257.372c24.352-24.394 24.352-63.898 0-88.289zM169.375 371.383l-86.914-86.91L299.996 66.938l86.914 86.91zm-99.156-63.809 75.93 75.926-114.016 37.96zm347.664-184.82-13.238 13.363L317.727 49.2l13.367-13.36c14.62-14.609 38.32-14.609 52.945 0l33.965 33.966c14.512 14.687 14.457 38.332-.121 52.949zm0 0"
        fill="#000000"
        opacity="1"
        data-original="#000000"
      ></path>
    </g>
  </svg>
)
export const RenameIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_286_481)">
      <path
        d="M12.1875 19.2188C12.1875 19.6503 11.8378 20 11.4063 20H4.17969C2.45651 20 1.05469 18.5982 1.05469 16.875V5.65842C1.05469 4.84726 1.36917 4.08325 1.94016 3.50723L4.51996 0.904541C5.08972 0.329742 5.88074 0 6.69022 0H13.7848C15.5078 0 16.9098 1.40182 16.9098 3.125V10.4297C16.9098 10.8612 16.5599 11.2109 16.1285 11.2109C15.697 11.2109 15.3473 10.8612 15.3473 10.4297V3.125C15.3473 2.26349 14.6463 1.5625 13.7848 1.5625H6.69022C6.29471 1.5625 5.90805 1.72363 5.62973 2.00455L3.04993 4.60724C2.92374 4.7345 2.82349 4.88068 2.75116 5.03906H4.92188C5.56793 5.03906 6.09375 4.5134 6.09375 3.86719C6.09375 3.43567 6.44348 3.08594 6.875 3.08594C7.30652 3.08594 7.65625 3.43567 7.65625 3.86719C7.65625 5.37491 6.4296 6.60156 4.92188 6.60156H2.61719V16.875C2.61719 17.7365 3.31802 18.4375 4.17969 18.4375H11.4063C11.8378 18.4375 12.1875 18.7872 12.1875 19.2188ZM18.2588 19.3135C17.802 19.7704 17.2017 19.9989 16.6016 19.9989C16.0014 19.9989 15.4012 19.7704 14.9443 19.3135L10.6722 15.0334C10.5769 14.938 10.5081 14.8198 10.4723 14.6899L9.59869 11.5367C9.52255 11.2621 9.60205 10.9679 9.80606 10.7689C10.0099 10.5699 10.3061 10.4977 10.5786 10.5806L13.6539 11.5147C13.777 11.5521 13.889 11.6193 13.9798 11.7104L18.2596 15.9996C19.1727 16.9128 19.1727 18.3997 18.2588 19.3135ZM11.9231 14.0749L14.7948 16.9519L15.8998 15.8469L13.0121 12.9527L11.4836 12.4886L11.9231 14.0749ZM17.1539 17.1039L17.0035 16.953L15.8986 18.0579L16.0497 18.2092C16.3538 18.5133 16.8494 18.5133 17.1539 18.2088C17.4587 17.9041 17.4587 17.4084 17.1539 17.1039Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_286_481">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export const PreviewIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_286_483)">
      <path
        d="M19.8464 10.3953C20.0513 10.1714 20.0513 9.82822 19.8464 9.60432C18.8137 8.47553 17.3613 7.45717 15.7566 6.73678C13.9394 5.92096 11.9488 5.48975 10 5.48975C8.0513 5.48975 6.06067 5.92096 4.24344 6.73678C2.6388 7.45713 1.18633 8.47553 0.153679 9.60432C-0.0511652 9.82822 -0.0511652 10.1714 0.153679 10.3953C1.18637 11.5241 2.6388 12.5425 4.24344 13.2629C6.06067 14.0787 8.0513 14.5099 10 14.5099C11.9488 14.5099 13.9394 14.0787 15.7566 13.2629C17.3613 12.5425 18.8137 11.5241 19.8464 10.3953ZM18.5943 9.99982C17.4584 11.0871 15.6868 12.2183 13.4967 12.8449C14.1298 12.0682 14.5101 11.0777 14.5101 9.99982C14.5101 8.92197 14.1298 7.93143 13.4967 7.15475C15.6868 7.78139 17.4584 8.9126 18.5943 9.99982ZM6.66184 9.99982C6.66184 8.15912 8.15934 6.66162 10 6.66162C11.8407 6.66162 13.3382 8.15912 13.3382 9.99982C13.3382 11.8405 11.8407 13.338 10 13.338C8.1593 13.338 6.66184 11.8405 6.66184 9.99982ZM1.40571 9.99982C2.54157 8.9126 4.31325 7.78139 6.50329 7.15475C5.87016 7.93143 5.48993 8.92197 5.48993 9.99982C5.48993 11.0777 5.87016 12.0682 6.50329 12.8449C4.31325 12.2183 2.54157 11.0871 1.40571 9.99982Z"
        fill="currentColor"
      />
      <path
        d="M10 7.98877C8.89109 7.98877 7.98898 8.89092 7.98898 9.99978C7.98898 11.1087 8.89113 12.0108 10 12.0108C11.1089 12.0108 12.011 11.1087 12.011 9.99978C12.011 8.89092 11.1089 7.98877 10 7.98877ZM10 10.839C9.5373 10.839 9.16086 10.4625 9.16086 9.99982C9.16086 9.53713 9.5373 9.16068 10 9.16068C10.4627 9.16068 10.8391 9.53713 10.8391 9.99982C10.8391 10.4625 10.4627 10.839 10 10.839Z"
        fill="currentColor"
      />
      <path
        d="M15.4688 1.17188H18.8281V4.53125C18.8281 4.85484 19.0905 5.11719 19.4141 5.11719C19.7377 5.11719 20 4.85484 20 4.53125V0.585938C20 0.262344 19.7377 0 19.4141 0H15.4688C15.1452 0 14.8828 0.262344 14.8828 0.585938C14.8828 0.909531 15.1452 1.17188 15.4688 1.17188Z"
        fill="currentColor"
      />
      <path
        d="M19.4141 14.8828C19.0905 14.8828 18.8281 15.1452 18.8281 15.4688V18.8281H15.4688C15.1452 18.8281 14.8828 19.0905 14.8828 19.4141C14.8828 19.7377 15.1452 20 15.4688 20H19.4141C19.7377 20 20 19.7377 20 19.4141V15.4688C20 15.1452 19.7377 14.8828 19.4141 14.8828Z"
        fill="currentColor"
      />
      <path
        d="M4.53125 18.8281H1.17188V15.4688C1.17188 15.1452 0.909531 14.8828 0.585938 14.8828C0.262344 14.8828 0 15.1452 0 15.4688V19.4141C0 19.7377 0.262344 20 0.585938 20H4.53125C4.85484 20 5.11719 19.7377 5.11719 19.4141C5.11719 19.0905 4.85484 18.8281 4.53125 18.8281Z"
        fill="currentColor"
      />
      <path
        d="M0.585938 5.11719C0.909531 5.11719 1.17188 4.85484 1.17188 4.53125V1.17188H4.53125C4.85484 1.17188 5.11719 0.909531 5.11719 0.585938C5.11719 0.262344 4.85484 0 4.53125 0H0.585938C0.262344 0 0 0.262344 0 0.585938V4.53125C0 4.85484 0.262344 5.11719 0.585938 5.11719Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_286_483">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export const DuplicateIconPlus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_286_499)">
      <path
        d="M11.4062 6.25H2.34375C1.05141 6.25 0 7.30141 0 8.59375V17.6562C0 18.9486 1.05141 20 2.34375 20H11.4062C12.6986 20 13.75 18.9486 13.75 17.6562V8.59375C13.75 7.30141 12.6986 6.25 11.4062 6.25ZM12.1875 17.6562C12.1875 18.087 11.837 18.4375 11.4062 18.4375H2.34375C1.91297 18.4375 1.5625 18.087 1.5625 17.6562V8.59375C1.5625 8.16297 1.91297 7.8125 2.34375 7.8125H11.4062C11.837 7.8125 12.1875 8.16297 12.1875 8.59375V17.6562ZM7.65625 10.7812H6.09375V12.3438H4.53125V13.9062H6.09375V15.4688H7.65625V13.9062H9.21875V12.3438H7.65625V10.7812ZM14.5312 3.125H3.125V4.6875H14.5312C14.962 4.6875 15.3125 5.03797 15.3125 5.46875V16.875H16.875V5.46875C16.875 4.17641 15.8236 3.125 14.5312 3.125ZM17.6562 0H6.25V1.5625H17.6562C18.087 1.5625 18.4375 1.91297 18.4375 2.34375V13.75H20V2.34375C20 1.05141 18.9486 0 17.6562 0Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_286_499">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export const DeleteOpenIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_286_503)">
      <path
        d="M18.6496 3.88871L14.4315 5.09553C14.4268 5.09706 14.4221 5.09859 14.4174 5.10021C13.9664 5.25712 13.6633 5.68338 13.6633 6.16099V7.3839H9.495L14.259 2.61993C14.5222 2.35678 14.5222 1.93016 14.259 1.66701L13.0519 0.45982C12.4388 -0.153273 11.4413 -0.153273 10.8282 0.45982L9.58699 1.70106L8.95162 1.06568C8.25102 0.365035 7.11099 0.365035 6.4103 1.06568L3.93245 3.54353C3.23185 4.24417 3.23185 5.3842 3.93245 6.08485L4.56783 6.72022L3.32659 7.96146C2.71354 8.57451 2.71354 9.57204 3.32659 10.1851L4.53373 11.3922C4.79684 11.6554 5.22355 11.6554 5.48671 11.3922L7.19473 9.68421V20.0799C7.19473 21.69 8.50469 23 10.1148 23H17.213C18.8232 23 20.1331 21.69 20.1331 20.0799C20.1331 19.6053 20.1331 5.17491 20.1331 4.95241C20.1332 4.18515 19.3777 3.642 18.6496 3.88871ZM4.88543 4.49646L7.36323 2.01865C7.53838 1.8435 7.82341 1.84346 7.99865 2.01865L8.63398 2.65403L5.5208 5.7672L4.88543 5.13188C4.71028 4.95668 4.71028 4.67165 4.88543 4.49646ZM5.01026 9.96277L4.27957 9.23212C4.19197 9.14452 4.19197 9.00198 4.27957 8.91439C4.75102 8.44293 11.5397 1.65434 11.7812 1.41279C11.8688 1.3252 12.0113 1.3252 12.0989 1.41279L12.8296 2.14349L5.01026 9.96277ZM18.7855 20.0799C18.7855 20.9469 18.0801 21.6523 17.2131 21.6523H10.1149C9.24783 21.6523 8.54247 20.9469 8.54247 20.0799V8.73164H18.7855V20.0799ZM18.7855 7.4202L15.011 7.38394V6.32455L18.7855 5.26125V7.4202Z"
        fill="currentColor"
      />
      <path
        d="M10.6658 19.9003C11.038 19.9003 11.3397 19.5986 11.3397 19.2264V11.1577C11.3397 10.7856 11.038 10.4839 10.6658 10.4839C10.2937 10.4839 9.992 10.7856 9.992 11.1577V19.2264C9.99196 19.5986 10.2937 19.9003 10.6658 19.9003Z"
        fill="currentColor"
      />
      <path
        d="M13.664 19.9003C14.0361 19.9003 14.3378 19.5986 14.3378 19.2264V11.1577C14.3378 10.7856 14.0361 10.4839 13.664 10.4839C13.2918 10.4839 12.9901 10.7856 12.9901 11.1577V19.2264C12.9901 19.5986 13.2918 19.9003 13.664 19.9003Z"
        fill="currentColor"
      />
      <path
        d="M16.662 19.9003C17.0342 19.9003 17.3359 19.5986 17.3359 19.2264V11.1577C17.3359 10.7856 17.0342 10.4839 16.662 10.4839C16.2899 10.4839 15.9882 10.7856 15.9882 11.1577V19.2264C15.9882 19.5986 16.2899 19.9003 16.662 19.9003Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_286_503">
        <rect width="23" height="23" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export const HamburgerTreeLine = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="23"
    height="17"
    viewBox="0 0 23 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.875 15.375H21.125M1.875 8.5H21.125M1.875 1.625H21.125"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export const DeleteOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.625 28.875C8.86875 28.875 8.22159 28.606 7.6835 28.0679C7.14542 27.5298 6.87592 26.8822 6.875 26.125V8.25C6.48542 8.25 6.15909 8.118 5.896 7.854C5.63292 7.59 5.50092 7.26367 5.5 6.875C5.49909 6.48633 5.63109 6.16 5.896 5.896C6.16092 5.632 6.48725 5.5 6.875 5.5H12.375C12.375 5.11042 12.507 4.78408 12.771 4.521C13.035 4.25792 13.3613 4.12592 13.75 4.125H19.25C19.6396 4.125 19.9664 4.257 20.2304 4.521C20.4944 4.785 20.6259 5.11133 20.625 5.5H26.125C26.5146 5.5 26.8414 5.632 27.1054 5.896C27.3694 6.16 27.5009 6.48633 27.5 6.875C27.4991 7.26367 27.3671 7.59046 27.104 7.85537C26.8409 8.12029 26.5146 8.25183 26.125 8.25V26.125C26.125 26.8813 25.856 27.5289 25.3179 28.0679C24.7798 28.6069 24.1322 28.8759 23.375 28.875H9.625ZM23.375 8.25H9.625V26.125H23.375V8.25ZM13.75 23.375C14.1396 23.375 14.4664 23.243 14.7304 22.979C14.9944 22.715 15.1259 22.3887 15.125 22V12.375C15.125 11.9854 14.993 11.6591 14.729 11.396C14.465 11.1329 14.1387 11.0009 13.75 11C13.3613 10.9991 13.035 11.1311 12.771 11.396C12.507 11.6609 12.375 11.9872 12.375 12.375V22C12.375 22.3896 12.507 22.7164 12.771 22.9804C13.035 23.2444 13.3613 23.3759 13.75 23.375ZM19.25 23.375C19.6396 23.375 19.9664 23.243 20.2304 22.979C20.4944 22.715 20.6259 22.3887 20.625 22V12.375C20.625 11.9854 20.493 11.6591 20.229 11.396C19.965 11.1329 19.6387 11.0009 19.25 11C18.8613 10.9991 18.535 11.1311 18.271 11.396C18.007 11.6609 17.875 11.9872 17.875 12.375V22C17.875 22.3896 18.007 22.7164 18.271 22.9804C18.535 23.2444 18.8613 23.3759 19.25 23.375Z"
      fill="currentColor"
    />
  </svg>
)
export const ViewSitemap = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 2C4.73478 2 4.48043 2.10536 4.29289 2.29289C4.10536 2.48043 4 2.73478 4 3V17C4 17.2652 4.10536 17.5196 4.29289 17.7071C4.48043 17.8946 4.73478 18 5 18H19C19.2652 18 19.5196 17.8946 19.7071 17.7071C19.8946 17.5196 20 17.2652 20 17V11.737C20 11.4718 20.1054 11.2174 20.2929 11.0299C20.4804 10.8424 20.7348 10.737 21 10.737C21.2652 10.737 21.5196 10.8424 21.7071 11.0299C21.8946 11.2174 22 11.4718 22 11.737V17C22 17.7956 21.6839 18.5587 21.1213 19.1213C20.5587 19.6839 19.7956 20 19 20H5C4.20435 20 3.44129 19.6839 2.87868 19.1213C2.31607 18.5587 2 17.7956 2 17V3C2 2.20435 2.31607 1.44129 2.87868 0.87868C3.44129 0.316071 4.20435 0 5 0H10.017C10.2822 0 10.5366 0.105357 10.7241 0.292893C10.9116 0.48043 11.017 0.734784 11.017 1C11.017 1.26522 10.9116 1.51957 10.7241 1.70711C10.5366 1.89464 10.2822 2 10.017 2H5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.411 0.571871C21.591 0.752391 21.6921 0.99693 21.6921 1.25187C21.6921 1.50681 21.591 1.75135 21.411 1.93187L12.639 10.7179C12.5498 10.8071 12.444 10.8778 12.3275 10.9261C12.211 10.9744 12.0861 10.9992 11.96 10.9992C11.8339 10.9992 11.709 10.9744 11.5925 10.9261C11.476 10.8778 11.3701 10.8071 11.281 10.7179C11.101 10.5374 10.9999 10.2928 10.9999 10.0379C10.9999 9.78293 11.101 9.53839 11.281 9.35787L20.054 0.571871C20.234 0.392033 20.478 0.291016 20.7325 0.291016C20.9869 0.291016 21.231 0.392033 21.411 0.571871Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.04 0C21.57 0 22 0.43 22 0.962V6C22 6.531 21.53 7 21 7C20.47 7 20 6.531 20 6V2H16C15.47 2 15 1.531 15 1C15 0.469 15.43 0 15.96 0H21.04Z"
      fill="currentColor"
    />
  </svg>
)
export const Upload = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.293 0.292786C7.48052 0.105315 7.73483 0 8 0C8.26516 0 8.51947 0.105315 8.707 0.292786L12.707 4.29279C12.8892 4.48139 12.9899 4.73399 12.9877 4.99619C12.9854 5.25838 12.8802 5.5092 12.6948 5.6946C12.5094 5.88001 12.2586 5.98518 11.9964 5.98746C11.7342 5.98974 11.4816 5.88894 11.293 5.70679L9 3.41379V12.9998C9 13.265 8.89464 13.5194 8.7071 13.7069C8.51957 13.8944 8.26521 13.9998 8 13.9998C7.73478 13.9998 7.48042 13.8944 7.29289 13.7069C7.10535 13.5194 7 13.265 7 12.9998V3.41379L4.707 5.70679C4.51839 5.88894 4.26579 5.98974 4.00359 5.98746C3.7414 5.98518 3.49058 5.88001 3.30518 5.6946C3.11977 5.5092 3.0146 5.25838 3.01232 4.99619C3.01004 4.73399 3.11084 4.48139 3.293 4.29279L7.293 0.292786Z"
      fill="currentColor"
    />
    <path
      d="M2 14C2 13.7348 1.89464 13.4804 1.70711 13.2929C1.51957 13.1054 1.26522 13 1 13C0.734784 13 0.48043 13.1054 0.292893 13.2929C0.105357 13.4804 0 13.7348 0 14V14.6C0 16.482 1.518 18 3.4 18H12.6C14.482 18 16 16.482 16 14.6V14C16 13.7348 15.8946 13.4804 15.7071 13.2929C15.5196 13.1054 15.2652 13 15 13C14.7348 13 14.4804 13.1054 14.2929 13.2929C14.1054 13.4804 14 13.7348 14 14V14.6C14 15.378 13.378 16 12.6 16H3.4C2.622 16 2 15.378 2 14.6V14Z"
      fill="currentColor"
    />
  </svg>
)
export const SettingLine = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="512"
    height="512"
    x="0"
    y="0"
    viewBox="0 0 682.667 682.667"
  >
    <g>
      <defs>
        <clipPath id="a" clipPathUnits="userSpaceOnUse">
          <path
            d="M0 512h512V0H0Z"
            fill="currentColor"
            opacity="1"
            data-original="currentColor"
          ></path>
        </clipPath>
      </defs>
      <g clipPath="url(#a)" transform="matrix(1.33333 0 0 -1.33333 0 682.667)">
        <path
          d="M0 0a191.783 191.783 0 0 0 49.719-20.638l15.688 15.69a32.121 32.121 0 0 0 22.727 9.415 32.116 32.116 0 0 0 22.718-9.415l22.718-22.719a32.11 32.11 0 0 0 9.415-22.718 32.113 32.113 0 0 0-9.415-22.726L117.881-88.8a191.838 191.838 0 0 0 20.638-49.719h22.147c17.746 0 32.134-14.388 32.134-32.133v-32.134c0-17.745-14.388-32.133-32.134-32.133h-22.147a191.831 191.831 0 0 0-20.638-49.718l15.689-15.689a32.117 32.117 0 0 0 9.415-22.727 32.11 32.11 0 0 0-9.415-22.718l-22.718-22.718a32.112 32.112 0 0 0-22.718-9.415 32.117 32.117 0 0 0-22.727 9.415L49.719-352.8A191.78 191.78 0 0 0 0-373.437v-22.148c0-17.746-14.388-32.134-32.134-32.134h-32.133c-17.746 0-32.133 14.388-32.133 32.134v22.148a191.78 191.78 0 0 0-49.719 20.637l-15.689-15.689a32.115 32.115 0 0 0-22.726-9.415 32.108 32.108 0 0 0-22.718 9.415l-22.719 22.718a32.114 32.114 0 0 0-9.415 22.718 32.121 32.121 0 0 0 9.415 22.727l15.69 15.689a191.796 191.796 0 0 0-20.638 49.718h-22.147c-17.746 0-32.134 14.388-32.134 32.133v32.134c0 17.745 14.388 32.133 32.134 32.133h22.147A191.803 191.803 0 0 0-214.281-88.8l-15.69 15.689a32.117 32.117 0 0 0-9.415 22.726 32.114 32.114 0 0 0 9.415 22.718l22.719 22.719a32.112 32.112 0 0 0 22.718 9.415 32.119 32.119 0 0 0 22.726-9.415l15.689-15.69A191.783 191.783 0 0 0-96.4 0v22.148c0 17.746 14.387 32.133 32.133 32.133h32.133C-14.388 54.281 0 39.894 0 22.148Z"
          transform="translate(304.2 442.719)"
          fill="none"
          stroke="currentColor"
          strokeWidth="30"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeDasharray="none"
          strokeOpacity=""
          data-original="currentColor"
          className=""
        ></path>
        <path
          d="M0 0c53.205 0 96.4-43.195 96.4-96.4 0-53.204-43.195-96.4-96.4-96.4-53.205 0-96.4 43.196-96.4 96.4C-96.4-43.195-53.205 0 0 0Z"
          transform="translate(256 352.4)"
          fill="none"
          stroke="currentColor"
          strokeWidth="30"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeDasharray="none"
          data-original="currentColor"
        ></path>
      </g>
    </g>
  </svg>
)
export const AIMagic = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 7L9.484 8.394C8.808 10.222 8.47 11.136 7.803 11.803C7.136 12.47 6.222 12.808 4.394 13.484L3 14L4.394 14.516C6.222 15.192 7.136 15.531 7.803 16.197C8.47 16.863 8.808 17.778 9.484 19.606L10 21L10.516 19.606C11.192 17.778 11.531 16.864 12.197 16.197C12.863 15.53 13.778 15.192 15.606 14.516L17 14L15.606 13.484C13.778 12.808 12.864 12.47 12.197 11.803C11.53 11.136 11.192 10.222 10.516 8.394L10 7ZM18 3L17.779 3.597C17.489 4.381 17.344 4.773 17.059 5.058C16.773 5.344 16.381 5.489 15.597 5.778L15 6L15.598 6.221C16.381 6.511 16.773 6.656 17.058 6.941C17.344 7.227 17.489 7.619 17.778 8.403L18 9L18.221 8.403C18.511 7.619 18.656 7.227 18.941 6.942C19.227 6.656 19.619 6.511 20.403 6.222L21 6L20.402 5.779C19.619 5.489 19.227 5.344 18.942 5.059C18.656 4.773 18.511 4.381 18.222 3.597L18 3Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export const ToggleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 17 14"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M1 1h15M1 7h15M1 13h15"
    ></path>
  </svg>
)

export const CheckAnimateIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 65 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 25L27.3077 44L58.5 7"
      stroke="white"
      strokeWidth="13"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export const ArrowDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="208"
    height="239"
    viewBox="0 0 208 239"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M104 3V236V3ZM104 236L205 135.094L104 236ZM104 236L3 135.094L104 236Z"
      fill="currentColor"
    />
    <path
      d="M104 3V236M104 236L205 135.094M104 236L3 135.094"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const QuotesIcons = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="83"
    height="68"
    viewBox="0 0 83 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M65.75 68C57.25 68 50.25 62.25 50.25 49.75C50.25 25 64.75 5.49999 82.25 0.499995V16.75C74.75 20 70 26.75 67.75 37C75.75 38 81.25 44.25 81.25 52.5C81.25 61.25 74.75 68 65.75 68ZM15.75 68C7.5 68 0.500001 62.25 0.500001 49.75C0.500001 25 15 5.49999 32.5 0.499995V16.75C25 20 20.25 26.75 18 37C25.75 38 31.5 44.25 31.5 52.5C31.5 61.25 25 68 15.75 68Z"
      fill="currentColor"
    />
  </svg>
)

export const DashboardIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="24"
    height="24"
    x="0"
    y="0"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    className=""
  >
    <g>
      <path
        d="M197.332 170.668h-160C16.746 170.668 0 153.922 0 133.332v-96C0 16.746 16.746 0 37.332 0h160c20.59 0 37.336 16.746 37.336 37.332v96c0 20.59-16.746 37.336-37.336 37.336zM37.332 32A5.336 5.336 0 0 0 32 37.332v96a5.337 5.337 0 0 0 5.332 5.336h160a5.338 5.338 0 0 0 5.336-5.336v-96A5.337 5.337 0 0 0 197.332 32zM197.332 512h-160C16.746 512 0 495.254 0 474.668v-224c0-20.59 16.746-37.336 37.332-37.336h160c20.59 0 37.336 16.746 37.336 37.336v224c0 20.586-16.746 37.332-37.336 37.332zm-160-266.668A5.337 5.337 0 0 0 32 250.668v224A5.336 5.336 0 0 0 37.332 480h160a5.337 5.337 0 0 0 5.336-5.332v-224a5.338 5.338 0 0 0-5.336-5.336zM474.668 512h-160c-20.59 0-37.336-16.746-37.336-37.332v-96c0-20.59 16.746-37.336 37.336-37.336h160c20.586 0 37.332 16.746 37.332 37.336v96C512 495.254 495.254 512 474.668 512zm-160-138.668a5.338 5.338 0 0 0-5.336 5.336v96a5.337 5.337 0 0 0 5.336 5.332h160a5.336 5.336 0 0 0 5.332-5.332v-96a5.337 5.337 0 0 0-5.332-5.336zM474.668 298.668h-160c-20.59 0-37.336-16.746-37.336-37.336v-224C277.332 16.746 294.078 0 314.668 0h160C495.254 0 512 16.746 512 37.332v224c0 20.59-16.746 37.336-37.332 37.336zM314.668 32a5.337 5.337 0 0 0-5.336 5.332v224a5.338 5.338 0 0 0 5.336 5.336h160a5.337 5.337 0 0 0 5.332-5.336v-224A5.336 5.336 0 0 0 474.668 32zm0 0"
        fill="currentColor"
        opacity="1"
        data-original="#000000"
        className=""
      ></path>
    </g>
  </svg>
)

export const OrderIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    version="1.1"
    width="24"
    height="24"
    x="0"
    y="0"
    viewBox="0 0 682.667 682.667"
    xmlSpace="preserve"
    className=""
  >
    <g>
      <defs>
        <clipPath id="a" clipPathUnits="userSpaceOnUse">
          <path
            d="M0 512h512V0H0Z"
            fill="currentColor"
            opacity="1"
            data-original="currentColor"
          ></path>
        </clipPath>
      </defs>
      <g clipPath="url(#a)" transform="matrix(1.33333 0 0 -1.33333 0 682.667)">
        <path
          d="M0 0c0-66.274-53.726-120-120-120S-240-66.274-240 0s53.726 120 120 120S0 66.274 0 0Z"
          transform="translate(256 135)"
          fill="currentColor"
          stroke="#000000"
          strokeWidth="30"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeDasharray="none"
          strokeOpacity=""
          data-original="#000000"
        ></path>
        <path
          d="M0 0h330c16.568 0 30 13.432 30 30v351.997L260.004 482H30c-16.568 0-30-13.432-30-30V240"
          transform="translate(136 15)"
          fill="currentColor"
          stroke="#000000"
          strokeWidth="30"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeDasharray="none"
          strokeOpacity=""
          data-original="#000000"
        ></path>
        <path
          d="M0 0v-100h100Z"
          transform="translate(396 497)"
          fill="none"
          stroke="#000000"
          strokeWidth="30"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeDasharray="none"
          strokeOpacity=""
          data-original="#000000"
        ></path>
        <path
          d="M0 0h210.638"
          transform="translate(215.362 225)"
          fill="none"
          stroke="#000000"
          strokeWidth="30"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeDasharray="none"
          strokeOpacity=""
          data-original="#000000"
        ></path>
        <path
          d="M0 0h220"
          transform="translate(206 315)"
          fill="none"
          stroke="#000000"
          strokeWidth="30"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeDasharray="none"
          strokeOpacity=""
          data-original="#000000"
        ></path>
        <path
          d="M0 0h170"
          transform="translate(256 135)"
          fill="none"
          stroke="#000000"
          strokeWidth="30"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeDasharray="none"
          strokeOpacity=""
          data-original="#000000"
        ></path>
        <path
          d="M0 0v60M0 0h40"
          transform="translate(136 135)"
          fill="none"
          stroke="#000000"
          strokeWidth="30"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeDasharray="none"
          strokeOpacity=""
          data-original="#000000"
        ></path>
      </g>
    </g>
  </svg>
)
export const DealsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="24"
    height="24"
    x="0"
    y="0"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    className=""
  >
    <g>
      <path
        d="M507.448 108.594c-2.844-2-6.49-2.49-9.76-1.281l-86.958 31.625c-10.781 3.917-19.365 11.813-24.167 22.229-.9 1.953-1.491 3.982-2.083 6.008-14.932-4.245-42.682-13.111-70.26-27.32-41.673-21.473-73.51-10.867-100.816 9.961-13.836.272-32.906 1.908-51.652 3.56-11.958 1.055-23.259 2.026-32.423 2.585a42.64 42.64 0 0 0-3.889-16.126c-4.802-10.417-13.385-18.313-24.167-22.229l-86.96-31.627a10.648 10.648 0 0 0-9.76 1.281A10.672 10.672 0 0 0 0 96v213.333A10.66 10.66 0 0 0 10.667 320h31.156c13.251 0 25.579-6.25 33.548-16.342 4.245 3.228 9.273 7.008 14.546 10.967 12.448 9.365 26.073 19.583 32.052 24.594 39.719 33.25 87.469 69.156 96.979 75.406 8.885 5.833 24.885 12.042 37.052 12.042 4.76 0 16.75 0 25.167-7.115 8.677 3.406 18.031 3.24 26.729-.594 8.677-3.823 15.698-11.031 19.781-19.792 8.333 1.708 17.906.458 26.583-3.896 8.135-4.073 14.125-10.24 17.333-17.448 7.708.708 15.938-1.802 23.302-7.438 10.522-8.043 15.34-19.921 13.977-31.639l27.057-14.969c7.924 10.741 20.518 17.556 34.247 17.556h31.156a10.66 10.66 0 0 0 10.667-10.667V117.334a10.668 10.668 0 0 0-4.551-8.74zM61.802 284.823c-3.104 8.281-11.135 13.844-19.979 13.844h-20.49V111.229l72.646 26.417c5.396 1.969 9.688 5.917 12.083 11.125 2.406 5.208 2.615 11.042.604 16.406L61.802 284.823zm320.146 68.615c-3.615 2.771-8.677 4.313-10.927 2.063-.115-.115-.293-.104-.411-.214-.204-.189-.305-.444-.526-.62-7.625-6.021-41.792-40.979-62.906-63-4.073-4.26-10.833-4.417-15.073-.323-4.26 4.073-4.406 10.823-.323 15.073 4.956 5.173 44.74 46.608 60.663 61.099-1.189 4.684-5.531 7.576-7.736 8.682-6.833 3.427-13.958 2.854-16.625.375-.079-.074-.197-.07-.279-.142-.13-.116-.188-.279-.326-.389-12.792-10.219-44.885-44.323-52.146-52.219-3.99-4.344-10.729-4.615-15.073-.635-4.333 3.99-4.625 10.74-.635 15.073.35.379 31.802 34.306 49.467 50.065-1.736 4.988-5.273 9.119-9.811 11.122-3.349 1.488-8.587 2.251-14.572-2.172-15.318-12.988-46.059-45.711-52.105-52.182-4.01-4.313-10.781-4.531-15.073-.51-4.302 4.021-4.531 10.771-.51 15.073 7.168 7.672 28.355 30.128 44.461 45.333a46.119 46.119 0 0 1-5.482.344c-7.063 0-19.198-4.51-25.333-8.542-7.479-4.917-54.438-39.958-94.99-73.917-6.135-5.146-20.135-15.677-32.948-25.302-6.867-5.155-13.194-9.908-17.857-13.495l39.938-106.516c10.367-.453 24.188-1.648 38.815-2.938 8.273-.729 16.555-1.44 24.469-2.056-12.164 12.487-30.249 34.852-27.865 55.816 1.094 9.542 6.313 17.49 15.115 22.99 17.427 10.906 49.688 1.76 65.229-17.354 10.031-1.448 16.813-4.01 24.208-7.677 12.5 11.75 29.26 25.563 46.865 40.073 30.646 25.25 65.385 53.875 74.573 69.927 5.114 8.928-1.979 15.345-4.271 17.095zm18.299-34.304c-14.212-19.012-45.02-44.449-75.039-69.186-20.01-16.49-38.906-32.063-51-44.156-3.333-3.313-8.448-4.063-12.573-1.865-10.865 5.823-15.76 8.229-28.031 9.458a10.673 10.673 0 0 0-7.958 4.927c-8.365 13.271-31.615 19.583-38.99 14.979-4.188-2.625-5-5.292-5.229-7.323-1.031-9.073 8.156-24.781 23.396-40.031 37.74-37.74 64.719-45.125 99.625-27.125 33.164 17.099 65.895 26.767 79.635 30.419.397 1.598.685 3.212 1.271 4.779l41.417 110.451-26.524 14.673zm90.42.866h-20.49c-8.844 0-16.875-5.563-19.979-13.844l-44.865-119.635c-2.01-5.375-1.802-11.208.604-16.417 2.396-5.208 6.688-9.156 12.083-11.125l72.646-26.417V320z"
        fill="currentColor"
        opacity="1"
        data-original="#000000"
        className=""
      ></path>
    </g>
  </svg>
)

export const ProductIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="24"
    height="24"
    x="0"
    y="0"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    className=""
  >
    <g>
      <path
        d="M131.756 352.381v149.064c-2.728 0-5.455-.641-7.967-1.923L17.569 445.37C11.407 442.231 7.5 435.73 7.5 428.618V300.389c0-3.586.993-7.015 2.769-9.942l121.487 61.934zM210.462 463.462 256 440.253V289.04l-124.241 63.342v149.06c2.721 0 5.455-.641 7.959-1.923l38.882-19.817"
        fill="currentColor"
        stroke="#000000"
        strokeWidth="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        data-original="#000000"
        className=""
      ></path>
      <path
        d="m256 289.04-124.241 63.342-121.495-61.939c1.681-2.758 4.064-5.08 6.967-6.628l114.529-61.552L256 289.04zM380.244 352.381v149.064c2.728 0 5.455-.641 7.967-1.923l106.22-54.151c6.162-3.139 10.069-9.64 10.069-16.752v-128.23c0-3.586-.993-7.015-2.768-9.942l-121.488 61.934zM380.241 352.382v149.06c-2.721 0-5.455-.641-7.959-1.923L256 440.253V289.04l124.241 63.342z"
        fill="currentColor"
        stroke="#000000"
        strokeWidth="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        data-original="#000000"
        className=""
      ></path>
      <path
        d="M316.1 256.737 256 289.04l124.241 63.342 121.495-61.939c-1.681-2.758-4.064-5.08-6.967-6.628l-50.38-27.076M256 138.273V289.04l-124.241-66.777-.003-135.977c0-3.586.993-7.015 2.768-9.941L256 138.273zM256 289.04V138.273l121.47-61.928a19.167 19.167 0 0 1 2.768 9.941l.001 27.396M377.47 76.344 256 138.273 134.524 76.344c1.682-2.763 4.059-5.08 6.961-6.634l106.204-57.055c.029-.012.053-.03.082-.042a17.473 17.473 0 0 1 16.534.042L370.509 69.71c2.902 1.555 5.285 3.871 6.961 6.634z"
        fill="currentColor"
        stroke="#000000"
        strokeWidth="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        data-original="#000000"
        className=""
      ></path>
      <path
        d="M433.996 173.149c-13.313-14.562-32.466-23.696-53.752-23.696-40.212 0-72.81 32.598-72.81 72.81s32.598 72.81 72.81 72.81 72.81-32.598 72.81-72.81c0-6.178-.769-12.176-2.218-17.904"
        fill="currentColor"
        stroke="#000000"
        strokeWidth="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        data-original="#000000"
        className=""
      ></path>
      <path
        d="m346.089 225.329 24.257 22.476 42.759-44.952"
        fill="currentColor"
        stroke="#000000"
        strokeWidth="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        data-original="#000000"
        className=""
      ></path>
    </g>
  </svg>
)
export const BrandsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    version="1.1"
    width="24"
    height="24"
    x="0"
    y="0"
    viewBox="0 0 510 510"
    xmlSpace="preserve"
    fillRule="evenodd"
    className=""
  >
    <g>
      <path
        d="m131.103 451.079 6.034 10.661.011.02c5.235 9.312 1.915 21.194-7.344 26.424l-21.725 12.313a.298.298 0 0 1-.024.014c-9.312 5.235-21.194 1.915-26.426-7.348L17.742 380.276c-5.283-9.32-1.963-21.214 7.308-26.45l21.75-12.313.007-.004c9.267-5.234 21.153-1.945 26.43 7.321l.01.019 4.871 8.606 56.631-32.787c17.18-9.936 34.739-16.399 53.609-10.272 18.282 5.928 48.128 18.708 78.588 24.212.352.064.701.152 1.042.262 15.533 5.029 24.97 20.737 20.729 36.51a34.555 34.555 0 0 1-2.279 6.156c3.072-.928 6.083-2.24 9.046-3.966l77.465-45.117c28.139-16.393 46.902-14.573 57.521-7.449 9.173 6.154 13.429 16.659 13.155 26.974-.277 10.424-5.252 20.378-13.427 25.412l-140.564 86.544c-14.86 9.172-31.137 11.325-47.999 6.827l-.009-.003-98.765-26.469zm-7.9 18.525L59.332 356.745c-.932-1.632-3.022-2.227-4.655-1.305l-21.745 12.31-.007.004c-1.623.916-2.188 3.002-1.264 4.632l.003.005 63.889 112.892.004.005c.92 1.631 3.014 2.197 4.652 1.279l21.706-12.303.01-.006c1.631-.921 2.197-3.015 1.278-4.654zm.019-32.45 14.509-8.378a7.996 7.996 0 0 1 6.071-.799l101.959 27.325c12.457 3.323 24.491 1.792 35.469-4.983l.008-.005 140.571-86.548c3.561-2.193 5.39-6.614 5.763-11.129.575-6.976-2.68-14.691-11.309-16.499-8.157-1.709-19.629 1.034-35.26 10.14l-77.463 45.116c-12.485 7.275-25.57 9.289-39.83 7.019l-9.975-1.631c-17.488-3.59-33.707-8.872-51.705-13.709-4.264-1.146-6.795-5.538-5.649-9.802s5.538-6.796 9.802-5.65c17.562 4.72 33.394 9.896 50.443 13.421 8.473.934 14.69-2.553 16.638-9.813l.001-.004c1.974-7.335-2.628-14.441-9.751-16.978-31.055-5.704-61.45-18.587-80.093-24.632l-.003-.001c-14.389-4.673-27.558 1.328-40.659 8.905l-56.76 32.862zm-71.78-68.685c4.93-.734 9.509 2.671 10.243 7.601.704 4.931-2.7 9.539-7.631 10.244-4.931.733-9.51-2.701-10.243-7.631-.705-4.931 2.7-9.51 7.631-10.214zm150.989-145.023-11.729-5.02c-13.959-5.983-22.02-19.943-20.238-35.006l.001-.01 2.299-19.233.003-.025c.446-3.636-.141-6.848-1.767-10.105l-8.726-17.257c-6.878-13.544-4.081-29.424 7.001-39.827l14.119-13.244.015-.014c2.668-2.491 4.291-5.316 5.114-8.852l.004-.017 4.432-18.86c3.439-14.776 15.79-25.141 30.948-25.99l.006-.001 19.334-1.068c3.647-.201 6.719-1.305 9.61-3.484l.018-.014 15.51-11.624.016-.012c12.173-9.076 28.248-9.076 40.421 0l.016.012 15.505 11.621c2.921 2.185 5.976 3.3 9.633 3.501l19.334 1.068.006.001c15.157.849 27.509 11.214 30.944 25.973l4.436 18.877.004.017c.823 3.536 2.446 6.361 5.114 8.852l.015.014 14.119 13.244c11.082 10.403 13.879 26.283 7.007 39.815l-8.732 17.269c-1.626 3.257-2.213 6.469-1.767 10.105l.003.025 2.299 19.233.001.01c1.782 15.065-6.242 29.025-20.242 35.007l-11.726 5.019 28.446 61.124c1.73 3.656 1.25 7.586-1.144 10.627-2.377 3.157-6.022 4.601-9.959 3.89l-29.197-5.093-14.91 25.602c-1.908 3.346-5.374 5.303-9.313 5.157-3.912-.145-7.153-2.238-8.892-5.86l-.04-.086-27.55-59.172-8.502-2.567-.04-.012c-3.452-1.062-6.705-1.062-10.157 0l-.04.012-8.502 2.567-27.518 59.103c-1.642 3.648-5 5.868-8.964 6.015-3.933.145-7.394-1.804-9.299-5.133l-14.897-25.626-29.226 5.094c-3.95.711-7.603-.744-9.944-3.874-2.411-3.088-2.882-7.006-1.157-10.644zm158.763 8.704c-.116.165-.23.334-.342.505l-10.579 16.176c-6.472 9.906-17.053 15.423-28.287 15.325l17.688 37.99 12.239-21.016a8 8 0 0 1 8.288-3.855l23.937 4.176zm-105.957 32.006c-11.234.098-21.814-5.419-28.285-15.322l-10.581-16.179c-.112-.171-.227-.34-.342-.505l-22.945 49.303 23.972-4.178a8 8 0 0 1 8.29 3.861l12.208 21.001zm44.017-237.549c-6.411-4.777-14.874-4.777-21.285 0L262.475 38.22c-5.524 4.16-11.384 6.29-18.348 6.672l-19.325 1.069c-7.961.446-14.454 5.882-16.26 13.642l-.004.016-4.435 18.876c-1.574 6.748-4.674 12.139-9.765 16.895l-14.113 13.239c-5.82 5.464-7.297 13.803-3.685 20.917l.007.012 8.742 17.291.016.032c3.094 6.188 4.19 12.294 3.345 19.201l-2.297 19.219c-.937 7.926 3.307 15.27 10.652 18.418l17.765 7.605c6.402 2.717 11.159 6.739 14.976 12.549l.009.014 10.59 16.193c4.375 6.696 12.323 9.568 19.979 7.27l18.529-5.594c6.633-2.036 12.884-2.036 19.517 0l18.529 5.594c7.656 2.298 15.604-.574 19.979-7.27l10.59-16.193.009-.014c3.817-5.81 8.574-9.832 14.976-12.549l17.768-7.606.005-.002c7.365-3.147 11.58-10.492 10.644-18.415l-2.297-19.219c-.845-6.907.251-13.013 3.345-19.201l.016-.032 8.742-17.291.007-.012c3.612-7.114 2.135-15.453-3.685-20.917L382.885 95.39c-5.091-4.756-8.192-10.147-9.765-16.895l-4.435-18.876-.004-.016c-1.806-7.76-8.299-13.196-16.26-13.642l-19.322-1.068c-6.963-.383-12.779-2.505-18.341-6.666l-.006-.004zm-10.622 201.836c-51.151 0-92.88-41.729-92.88-92.879s41.729-92.879 92.88-92.879c51.107 0 92.839 41.728 92.839 92.879s-41.732 92.879-92.839 92.879zm0-16c42.301 0 76.839-34.541 76.839-76.879s-34.538-76.879-76.839-76.879c-42.339 0-76.88 34.54-76.88 76.879s34.541 76.879 76.88 76.879zM267.295 109.13l8.57-26.377a13.401 13.401 0 0 1 12.746-9.26 13.402 13.402 0 0 1 12.747 9.26l8.57 26.377h27.734a13.402 13.402 0 0 1 7.878 24.245l-22.437 16.302 8.57 26.377a13.402 13.402 0 0 1-20.624 14.984l-22.438-16.302-22.437 16.302a13.401 13.401 0 0 1-20.624-14.984l8.57-26.377-22.437-16.302a13.402 13.402 0 0 1 7.878-24.245zm-19.74 16 17.497 12.712a13.401 13.401 0 0 1 4.868 14.984l-6.683 20.569 17.497-12.712a13.401 13.401 0 0 1 15.755 0l17.497 12.712-6.683-20.569a13.401 13.401 0 0 1 4.868-14.984l17.497-12.712h-21.627a13.402 13.402 0 0 1-12.746-9.261l-6.684-20.568-6.683 20.568a13.402 13.402 0 0 1-12.746 9.261zM128.673 49.277a53.324 53.324 0 0 0 28.859 28.859 8 8 0 0 1 0 14.788 53.327 53.327 0 0 0-28.859 28.859 8.002 8.002 0 0 1-14.788 0 53.33 53.33 0 0 0-28.859-28.859 8 8 0 0 1 0-14.788 53.327 53.327 0 0 0 28.859-28.859 7.999 7.999 0 0 1 14.788 0zm-7.394 19.538a69.516 69.516 0 0 1-16.715 16.715 69.552 69.552 0 0 1 16.715 16.715 69.534 69.534 0 0 1 16.715-16.715 69.516 69.516 0 0 1-16.715-16.715zm339.695 88.204a53.324 53.324 0 0 0 28.859 28.859 8 8 0 0 1 0 14.788 53.327 53.327 0 0 0-28.859 28.859 8.002 8.002 0 0 1-14.788 0 53.333 53.333 0 0 0-28.859-28.859 8 8 0 0 1 0-14.788 53.33 53.33 0 0 0 28.859-28.859 7.999 7.999 0 0 1 14.788 0zm-7.394 19.538a69.516 69.516 0 0 1-16.715 16.715 69.57 69.57 0 0 1 16.715 16.715 69.534 69.534 0 0 1 16.715-16.715 69.498 69.498 0 0 1-16.715-16.715zm7.394-127.28a53.324 53.324 0 0 0 28.859 28.859 8 8 0 0 1 0 14.788 53.327 53.327 0 0 0-28.859 28.859 8.002 8.002 0 0 1-14.788 0 53.333 53.333 0 0 0-28.859-28.859 8 8 0 0 1 0-14.788 53.33 53.33 0 0 0 28.859-28.859 7.999 7.999 0 0 1 14.788 0zm-7.394 19.538a69.516 69.516 0 0 1-16.715 16.715 69.57 69.57 0 0 1 16.715 16.715 69.534 69.534 0 0 1 16.715-16.715 69.498 69.498 0 0 1-16.715-16.715zM140.758 209.977a53.328 53.328 0 0 0 28.858 28.859 7.998 7.998 0 0 1 0 14.788 53.325 53.325 0 0 0-28.858 28.859 8 8 0 0 1-14.788 0 53.33 53.33 0 0 0-28.859-28.859 8 8 0 0 1 0-14.788 53.333 53.333 0 0 0 28.859-28.859 8 8 0 0 1 14.788 0zm-7.394 19.538a69.57 69.57 0 0 1-16.715 16.715 69.552 69.552 0 0 1 16.715 16.715 69.498 69.498 0 0 1 16.715-16.715 69.516 69.516 0 0 1-16.715-16.715z"
        fill="currentColor"
        opacity="1"
        data-original="#000000"
        className=""
      ></path>
    </g>
  </svg>
)

export const SettingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="24"
    height="24"
    x="0"
    y="0"
    viewBox="0 0 682.667 682.667"
    xmlSpace="preserve"
    className=""
  >
    <g>
      <defs>
        <clipPath id="a" clipPathUnits="userSpaceOnUse">
          <path d="M0 512h512V0H0Z" fill="currentColor" opacity="1" data-original="#000000"></path>
        </clipPath>
      </defs>
      <g clipPath="url(#a)" transform="matrix(1.33333 0 0 -1.33333 0 682.667)">
        <path
          d="M0 0a191.783 191.783 0 0 0 49.719-20.638l15.688 15.69a32.121 32.121 0 0 0 22.727 9.415 32.116 32.116 0 0 0 22.718-9.415l22.718-22.719a32.11 32.11 0 0 0 9.415-22.718 32.113 32.113 0 0 0-9.415-22.726L117.881-88.8a191.838 191.838 0 0 0 20.638-49.719h22.147c17.746 0 32.134-14.388 32.134-32.133v-32.134c0-17.745-14.388-32.133-32.134-32.133h-22.147a191.831 191.831 0 0 0-20.638-49.718l15.689-15.689a32.117 32.117 0 0 0 9.415-22.727 32.11 32.11 0 0 0-9.415-22.718l-22.718-22.718a32.112 32.112 0 0 0-22.718-9.415 32.117 32.117 0 0 0-22.727 9.415L49.719-352.8A191.78 191.78 0 0 0 0-373.437v-22.148c0-17.746-14.388-32.134-32.134-32.134h-32.133c-17.746 0-32.133 14.388-32.133 32.134v22.148a191.78 191.78 0 0 0-49.719 20.637l-15.689-15.689a32.115 32.115 0 0 0-22.726-9.415 32.108 32.108 0 0 0-22.718 9.415l-22.719 22.718a32.114 32.114 0 0 0-9.415 22.718 32.121 32.121 0 0 0 9.415 22.727l15.69 15.689a191.796 191.796 0 0 0-20.638 49.718h-22.147c-17.746 0-32.134 14.388-32.134 32.133v32.134c0 17.745 14.388 32.133 32.134 32.133h22.147A191.803 191.803 0 0 0-214.281-88.8l-15.69 15.689a32.117 32.117 0 0 0-9.415 22.726 32.114 32.114 0 0 0 9.415 22.718l22.719 22.719a32.112 32.112 0 0 0 22.718 9.415 32.119 32.119 0 0 0 22.726-9.415l15.689-15.69A191.783 191.783 0 0 0-96.4 0v22.148c0 17.746 14.387 32.133 32.133 32.133h32.133C-14.388 54.281 0 39.894 0 22.148Z"
          transform="translate(304.2 442.719)"
          fill="currentColor"
          stroke="#000000"
          strokeWidth="30"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeDasharray="none"
          strokeOpacity=""
          data-original="#000000"
          className=""
        ></path>
        <path
          d="M0 0c53.205 0 96.4-43.195 96.4-96.4 0-53.204-43.195-96.4-96.4-96.4-53.205 0-96.4 43.196-96.4 96.4C-96.4-43.195-53.205 0 0 0Z"
          transform="translate(256 352.4)"
          fill="currentColor"
          stroke="#000000"
          strokeWidth="30"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeDasharray="none"
          strokeOpacity=""
          data-original="#000000"
          className=""
        ></path>
      </g>
    </g>
  </svg>
)

export const CustomerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="24"
    height="24"
    x="0"
    y="0"
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    className=""
  >
    <g>
      <path
        d="M59.923 35.052 51 31.333v-2.67A9.948 9.948 0 0 0 55.8 22h.2a3 3 0 0 0 .082-6l.98-2.272a8.078 8.078 0 0 0-4.07-10.551L50.2 1.907a10.248 10.248 0 0 0-10.232 1.112l-1.556 1.174a6.259 6.259 0 0 0-3.8 2.831 6.2 6.2 0 0 0-.552 5.216 10.372 10.372 0 0 0-4.561.111 8.047 8.047 0 0 0-4.507-9.173L22.2 1.907a10.248 10.248 0 0 0-10.232 1.112l-1.556 1.174a6.23 6.23 0 0 0-4.03 8.822L7.876 16A3 3 0 0 0 8 22h.2a9.962 9.962 0 0 0 4.8 6.661v2.672l-8.923 3.719A4.987 4.987 0 0 0 1 39.667V53a1 1 0 0 0 1 1h7v8a1 1 0 0 0 1 1h44a1 1 0 0 0 1-1v-8h7a1 1 0 0 0 1-1V39.667a4.987 4.987 0 0 0-3.077-4.615Zm-24.55-20.325L38.164 16a6.078 6.078 0 0 1 3.061 7.939l-.3.685-1.025-2.071a1 1 0 0 0-1.5-.353l-1.6 1.2a8 8 0 0 1-9.6 0l-1.6-1.2a.989.989 0 0 0-.829-.173 1 1 0 0 0-.666.526L23 24.771l-.826-1.651a4.229 4.229 0 0 1 3.78-6.12 4.671 4.671 0 0 1 3.893 2.083l.314.472 1.664-1.11-.314-.471a6.661 6.661 0 0 0-3.771-2.724 8.213 8.213 0 0 1 7.633-.523ZM42 29h1a1 1 0 0 1 0 2h-1ZM29 40.539a9.992 9.992 0 0 0 6 0v2.047l-3 3-3-3ZM32 39a8.009 8.009 0 0 1-8-8v-3.764l1.358-2.717L26 25a10 10 0 0 0 12 0l.642-.481L40 27.236V31a8.009 8.009 0 0 1-8 8Zm-10-8h-1a1 1 0 0 1 0-2h1ZM9 51.04V52H3V39.667A2.994 2.994 0 0 1 4.846 36.9l9.539-3.974A1 1 0 0 0 15 32v-3.936a1.046 1.046 0 0 0-.579-.907 7.968 7.968 0 0 1-4.372-6.267 1 1 0 0 0-.994-.89H8a1 1 0 0 1 0-2h1a1 1 0 0 0 1-1.007l-.007-1a1 1 0 0 0-.105-.44L8.171 12.12a4.228 4.228 0 0 1 2.888-6.02 1.025 1.025 0 0 0 .391-.179l1.72-1.3a8.218 8.218 0 0 1 8.2-.89L24.164 5a6.078 6.078 0 0 1 3.061 7.939l-.162.375a9.687 9.687 0 0 0-1.093.705L24.393 15.2a6.221 6.221 0 0 0-4.014 8.812L21.875 27H21a3 3 0 0 0 0 6h1.2a10.024 10.024 0 0 0 4.8 6.647v2.593l-14.338 3.983A5.014 5.014 0 0 0 9 51.04ZM53 61h-6v-8h-2v8H19v-8h-2v8h-6v-9.96a3.007 3.007 0 0 1 2.2-2.89l14.509-4.03 3.587 3.587a1 1 0 0 0 1.414 0l3.587-3.587L50.8 48.15a3.007 3.007 0 0 1 2.2 2.89Zm8-9h-6v-.96a5.014 5.014 0 0 0-3.662-4.817L37 42.24v-2.593A10.024 10.024 0 0 0 41.8 33H43a3 3 0 0 0 0-6h-.918l.98-2.271a8.078 8.078 0 0 0-4.07-10.551l-2.32-1.057-.5-1A4.228 4.228 0 0 1 39.059 6.1a1.025 1.025 0 0 0 .391-.179l1.72-1.3a8.218 8.218 0 0 1 8.2-.89L52.164 5a6.078 6.078 0 0 1 3.061 7.939l-1.15 2.661a1 1 0 0 0-.082.4L54 17a1 1 0 0 0 1 1h1a1 1 0 0 1 0 2h-1.055a1 1 0 0 0-.994.89 7.964 7.964 0 0 1-4.4 6.279 1 1 0 0 0-.555.895V32a1 1 0 0 0 .615.923l9.543 3.977A2.994 2.994 0 0 1 61 39.667Z"
        fill="currentColor"
        opacity="1"
        data-original="#000000"
        className=""
      ></path>
    </g>
  </svg>
)

export const CotegoryIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="24"
    height="24"
    x="0"
    y="0"
    viewBox="0 0 1024 1024"
    xmlSpace="preserve"
    className=""
  >
    <g>
      <path
        d="m23.428 326.715 475.428 182.857c4.25 1.607 8.679 2.428 13.144 2.428s8.892-.821 13.144-2.428l475.428-182.857c14.106-5.43 23.428-19.001 23.428-34.144s-9.322-28.714-23.428-34.143L525.144 75.571a37.028 37.028 0 0 0-26.286 0L23.43 258.428C9.322 263.858 0 277.43 0 292.571s9.322 28.714 23.428 34.144zM512 148.893l373.535 143.678L512 436.25 138.465 292.57zM1000.572 697.285l-104.82-40.321-101.894 39.213 91.677 35.252L512 875.107 138.465 731.429l91.679-35.25-101.893-39.214-104.822 40.322C9.322 702.715 0 716.287 0 731.43s9.322 28.714 23.428 34.143l475.428 182.857c4.25 1.607 8.679 2.428 13.144 2.428s8.892-.82 13.144-2.428l475.428-182.857c14.106-5.43 23.428-19.001 23.428-34.143s-9.322-28.714-23.428-34.144z"
        fill="currentColor"
        opacity="1"
        data-original="#000000"
        className=""
      ></path>
      <path
        d="m1000.572 477.857-104.82-40.322-101.894 39.214L885.535 512 512 655.678 138.465 512l91.679-35.25-101.893-39.213-104.822 40.322C9.322 483.286 0 496.858 0 512s9.322 28.714 23.428 34.143L498.856 729c4.25 1.608 8.679 2.429 13.144 2.429s8.892-.821 13.144-2.429l475.428-182.857c14.106-5.429 23.428-19 23.428-34.143s-9.322-28.714-23.428-34.143z"
        fill="currentColor"
        opacity="1"
        data-original="#000000"
        className=""
      ></path>
    </g>
  </svg>
)

export const PagesIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="24"
    height="24"
    x="0"
    y="0"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    className=""
  >
    <g>
      <path
        d="M441.363 0H151.925c-15.265 0-27.683 12.418-27.683 27.683v12.931h-12.961c-15.265 0-27.683 12.418-27.683 27.683v12.93H70.645c-15.269 0-27.69 12.416-27.69 27.677v375.421c0 15.261 12.421 27.677 27.69 27.677h289.424c15.268 0 27.69-12.416 27.69-27.677v-12.937h12.961c15.265 0 27.683-12.418 27.683-27.683v-12.93h12.961c15.265 0 27.683-12.419 27.683-27.684V27.683C469.045 12.418 456.627 0 441.363 0zm-81.294 492H70.645c-4.24 0-7.69-3.443-7.69-7.677V108.902c0-4.233 3.45-7.677 7.69-7.677h223.717v63.341c0 5.522 4.478 10 10 10h63.397v309.757c-.001 4.234-3.45 7.677-7.69 7.677zm-6.466-337.434h-39.241v-39.212zm54.799 289.138a7.683 7.683 0 0 1-7.683 7.683h-12.961V164.616l-.008-.476a9.44 9.44 0 0 0-2.766-6.487l-.001-.001c-.052-.054-73.553-73.501-73.553-73.501l-.293-.276a9.824 9.824 0 0 0-6.773-2.65H103.598v-12.93a7.683 7.683 0 0 1 7.683-7.683h289.438a7.683 7.683 0 0 1 7.683 7.683zm40.643-40.613c0 4.236-3.446 7.684-7.683 7.684h-12.961V68.296c0-15.265-12.418-27.683-27.683-27.683H144.242v-12.93c0-4.236 3.447-7.683 7.683-7.683h289.437c4.236 0 7.683 3.446 7.683 7.683z"
        fill="currentColor"
        opacity="1"
        data-original="currentColor"
        className=""
      ></path>
    </g>
  </svg>
)

export const NewCustomerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="24"
    height="24"
    x="0"
    y="0"
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    className=""
  >
    <g>
      <path
        d="M48.91 60.09A11.09 11.09 0 1 1 60 49a11.1 11.1 0 0 1-11.09 11.09Zm0-20.18A9.09 9.09 0 1 0 58 49a9.11 9.11 0 0 0-9.09-9.09ZM38 60H16a9 9 0 0 1-9-9 18 18 0 0 1 18-18h14a18.12 18.12 0 0 1 5.29.79 1 1 0 1 1-.58 1.91A16.23 16.23 0 0 0 39 35H25A16 16 0 0 0 9 51a7 7 0 0 0 7 7h22a1 1 0 0 1 0 2Zm11-5a1 1 0 0 1-1-1v-4h-4a1 1 0 0 1 0-2h4v-4a1 1 0 0 1 2 0v4h4a1 1 0 0 1 0 2h-4v4a1 1 0 0 1-1 1ZM32 30a13 13 0 1 1 13-13 13 13 0 0 1-13 13Zm0-24a11 11 0 1 0 11 11A11 11 0 0 0 32 6Z"
        fill="currentColor"
        opacity="1"
        data-original="#000000"
      ></path>
    </g>
  </svg>
)
export const Fillstar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="20"
    height="20"
    x="0"
    y="0"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    className="hovered-paths"
  >
    <g>
      <path
        fill="#ff1b1b"
        d="M184.37 183.929 35.947 205.497h-.018l215.977 48.497z"
        opacity="1"
        data-original="#ff1b1b"
        className=""
      ></path>
      <g fill="#c71515">
        <path
          d="m119.345 469.062 135.305-71.135V260.85L119.336 469.062zM259.932 259.86l134.225 206.566-25.76-150.205zM479.148 207.575l-219.252 49.226 110.076 57.197zM257.35 45.709v207.259l67.823-69.812z"
          fill="#c71515"
          opacity="1"
          data-original="#c71515"
          className=""
        ></path>
      </g>
      <g fill="#ff1b1b">
        <path
          d="m32.843 207.575 109.149 106.396.63.612 109.491-57.782-.801-.18zM117.833 466.426l134.208-206.521-108.619 57.315zM257.35 397.927l135.305 71.144L257.35 260.85zM328.115 184.002l-68.004 69.982 215.924-48.478zM254.65 252.95V45.709l-67.643 137.06z"
          fill="#ff1b1b"
          opacity="1"
          data-original="#ff1b1b"
          className=""
        ></path>
      </g>
      <path
        fill="#7a0d0d"
        d="m371.196 316.563 1.286-1.26L486.4 204.273l-155.963-22.665-3.24-.468-.018-.045L257.35 39.609 256 36.874l-1.349 2.735-69.632 141.1-.216.432-2.735.396-146.535 21.296-9.933 1.44 114.52 111.624.675.666-.387 2.24-26.804 156.324 141.045-74.149 1.349-.711 1.35.711 141.045 74.149-26.993-157.34zM35.947 205.497 184.37 183.93l67.536 70.065-215.977-48.498zm-3.104 2.078 218.469 49.046.8.18-109.491 57.782-.63-.612zM143.422 317.22l108.619-57.314-134.208 206.52zm111.228 80.707-135.305 71.135h-.009L254.65 260.85zm0-144.977-67.644-70.181 67.644-137.06zm115.322 61.048-110.076-57.197 219.252-49.226zm-41.857-129.996 147.92 21.504-215.923 48.479zM257.35 45.709l67.823 137.447-67.823 69.812zm0 352.218V260.85l135.305 208.221zm2.582-138.067 108.466 56.361 25.76 150.205z"
        opacity="1"
        data-original="#7a0d0d"
        className="hovered-path"
      ></path>
      <g fill="#fff">
        <path
          d="m257.35 260.85 135.305 208.221s-51.718-62.413-83.509-112.8c-31.792-50.385-51.796-95.421-51.796-95.421zM117.833 466.426l134.208-206.52s-42.469 48.98-74.26 97.566-59.948 108.954-59.948 108.954zM32.843 207.575l218.469 49.046s-53.683-6.52-107.395-16.718c-53.712-10.197-111.074-32.328-111.074-32.328zM254.65 252.95V45.709s-5.488 62.23-6.688 116.815c-1.199 54.586 6.688 90.426 6.688 90.426zM260.111 253.984l215.923-48.479s-58.031 6.205-107.961 17.002c-49.93 10.798-107.962 31.477-107.962 31.477z"
          opacity="1"
          fill="#ffffff40"
          data-original="#ffffff40"
          className=""
        ></path>
      </g>
      <g opacity=".2">
        <path
          d="M257.35 45.709s44.598 103.019 45.198 126.413c.6 23.393-45.198 80.846-45.198 80.846l67.823-69.812zM259.896 256.801s88.955 38.664 108.178 39.487 111.075-88.713 111.075-88.713L369.972 313.998zM259.932 259.86l108.466 56.361 25.76 150.205s-26.828-132.348-34.326-141.945c-7.498-9.598-99.9-64.621-99.9-64.621zM119.345 469.062l135.305-71.135V260.85s-6.088 112.817-14.486 126.613-120.819 81.599-120.819 81.599z"
          fill="#000000"
          opacity="1"
          data-original="#000000"
          className=""
        ></path>
      </g>
      <path
        fill="#fff"
        d="m35.947 205.497 215.959 48.497s-63.955-20.689-109.829-32.086c-45.874-11.396-106.13-16.411-106.13-16.411z"
        opacity=".3"
      ></path>
    </g>
  </svg>
)

export const Emptystar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="20"
    height="20"
    x="0"
    y="0"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    fillRule="evenodd"
    className=""
  >
    <g>
      <path
        fill="#e31e24"
        d="m3 187-1-1h179v-1h1l10-24L256 2v1-1l64 159 10 24h180s-1 1-1 2c-16 17-151 115-151 115l59 185h-5l-7-3c-29-16-143-84-143-84l-162 87h-5l59-185S18 204 3 187zm394 272-87-173 121-72-138 8-38-119-38 119-138-8 121 72-80 168 142-104 134 109z"
        opacity="1"
        data-original="#e31e24"
        className=""
      ></path>
    </g>
  </svg>
)
